// THIS FILE IS AUTO-GENERATED. DO NOT EDIT MANUALLY.
// Run: sh packages/api-types/scripts/run_generate_api_types.sh

import {
  arraySchema,
  booleanSchema,
  lazySchema,
  literalSchema,
  nullSchema,
  numberSchema,
  objectSchema,
  recordSchema,
  stringSchema,
  tupleSchema,
  unionSchema,
  unknownSchema,
  type RuntimeSchema,
} from './runtime'

export const UnknownSchema = unknownSchema

export const AbcSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'abcValues': { schema: lazySchema(() => AbcValuesSchema), optional: false },
  'sameValues': { schema: lazySchema(() => SameValuesSchema), optional: false },
  'originalValues': { schema: lazySchema(() => AbcValuesSchema), optional: false },
}))

export const AbcValuesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'a': { schema: numberSchema, optional: false },
  'b': { schema: numberSchema, optional: false },
  'c': { schema: numberSchema, optional: false },
}))

export const AcceptProjectInviteRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'token': { schema: stringSchema, optional: false },
}))

export const AcceptProjectInviteResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ProjectSchema), optional: false },
}))

export const AddRingResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RingSchema), optional: false },
}))

export const AnalysisMethodsSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("azimuthalIntegration"), literalSchema("dislocationDensity"), literalSchema("instrumentalFileCreation"), literalSchema("leBail"), literalSchema("peakFitting"), literalSchema("phaseQuantification"), literalSchema("rietveld"), literalSchema("stressStrain"), literalSchema("dataCalibration")]))

export const AnalysisRequestTypeSchema: RuntimeSchema = lazySchema(() => unionSchema([lazySchema(() => AzimuthalIntegrationRequestSchema), lazySchema(() => DislocationDensityRequestSchema), lazySchema(() => InstrumentalFileCreationRequestSchema), lazySchema(() => LeBailRequestSchema), lazySchema(() => PeakFittingRequestSchema), lazySchema(() => PhaseQuantificationRequestSchema), lazySchema(() => RietveldRequestSchema), lazySchema(() => StressStrainRequestSchema), lazySchema(() => DataCalibrationRequestSchema)]))

export const ApiProblemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'type': { schema: stringSchema, optional: true },
  'title': { schema: stringSchema, optional: false },
  'status': { schema: lazySchema(() => ApiProblemStatusSchema), optional: false },
  'detail': { schema: stringSchema, optional: false },
  'code': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'errorId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'validationIssues': { schema: unionSchema([arraySchema(lazySchema(() => ApiValidationIssueSchema)), nullSchema]), optional: true },
  'inaccessibleReferences': { schema: unionSchema([arraySchema(stringSchema), nullSchema]), optional: true },
  'activeJobId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ApiProblemStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema(400), literalSchema(403), literalSchema(404), literalSchema(409), literalSchema(500), literalSchema(504)]))

export const ApiValidationIssueSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'location': { schema: arraySchema(unionSchema([stringSchema, numberSchema])), optional: false },
  'message': { schema: stringSchema, optional: false },
  'code': { schema: stringSchema, optional: false },
}))

export const ArPlsBaselineModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'baselineFunction': { schema: unionSchema([literalSchema("arPLS")]), optional: false },
  'lambda0': { schema: numberSchema, optional: false },
  'lambdaMin': { schema: numberSchema, optional: false },
  'lambdaMax': { schema: numberSchema, optional: false },
  'ratio': { schema: numberSchema, optional: false },
  'vary': { schema: booleanSchema, optional: false },
}))

export const AxisRangeRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'detectorFiles': { schema: arraySchema(lazySchema(() => FilesFilterFileModelSchema)), optional: false },
  'poniFiles': { schema: arraySchema(lazySchema(() => FilesFilterFileModelSchema)), optional: false },
  'xAxisUnit': { schema: lazySchema(() => AxisUnitSchema), optional: false },
}))

export const AxisRangeResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RangeModelSchema), optional: false },
}))

export const AxisUnitSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("2th_deg"), literalSchema("q_A^-1"), literalSchema("q_nm^-1")]))

export const AzimuthalIntegrationDetectorCombinedRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'detectorFiles': { schema: arraySchema(stringSchema), optional: false },
  'poniFiles': { schema: arraySchema(stringSchema), optional: false },
  'imageOptions': { schema: lazySchema(() => ImageOptionsModelSchema), optional: false },
  'radialRange': { schema: unionSchema([lazySchema(() => AzimuthalIntegrationPreviewRangeModelSchema), nullSchema]), optional: true },
  'azimuthalRange': { schema: unionSchema([lazySchema(() => RangeModelSchema), nullSchema]), optional: true },
  'numberOfAzimuthalBins': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'displayOptions': { schema: unionSchema([lazySchema(() => AzimuthalIntegrationDetectorDisplayOptionsSchema), nullSchema]), optional: true },
  'point': { schema: unionSchema([lazySchema(() => XySchema), nullSchema]), optional: true },
}))

export const AzimuthalIntegrationDetectorCombinedResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => AzimuthalIntegrationDetectorDataSchema), optional: false },
}))

export const AzimuthalIntegrationDetectorDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'url': { schema: stringSchema, optional: false },
  'imageSize': { schema: unionSchema([lazySchema(() => AzimuthalIntegrationPreviewImageSizeSchema), nullSchema]), optional: true },
  'resolvedRange': { schema: unionSchema([lazySchema(() => AzimuthalIntegrationPreviewRangeModelSchema), nullSchema]), optional: true },
  'selectionHint': { schema: unionSchema([unionSchema([literalSchema("lower"), literalSchema("upper"), literalSchema("closest")]), nullSchema]), optional: true },
}))

export const AzimuthalIntegrationDetectorDisplayOptionsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'showRings': { schema: booleanSchema, optional: true },
  'showCakes': { schema: booleanSchema, optional: true },
}))

export const AzimuthalIntegrationDetectorRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
  'calibrationViewFile': { schema: stringSchema, optional: false },
  'imageOptions': { schema: lazySchema(() => ImageOptionsModelSchema), optional: false },
  'radialRange': { schema: unionSchema([lazySchema(() => AzimuthalIntegrationPreviewRangeModelSchema), nullSchema]), optional: true },
  'azimuthalRange': { schema: unionSchema([lazySchema(() => RangeModelSchema), nullSchema]), optional: true },
  'numberOfAzimuthalBins': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'displayOptions': { schema: unionSchema([lazySchema(() => AzimuthalIntegrationDetectorDisplayOptionsSchema), nullSchema]), optional: true },
  'point': { schema: unionSchema([lazySchema(() => XySchema), nullSchema]), optional: true },
}))

export const AzimuthalIntegrationDetectorResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => AzimuthalIntegrationDetectorDataSchema), optional: false },
}))

export const AzimuthalIntegrationFilesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'dataFiles': { schema: arraySchema(arraySchema(lazySchema(() => FilesFilterModelSchema))), optional: false },
  'calibrationFiles': { schema: arraySchema(lazySchema(() => FilesFilterFileModelSchema)), optional: false },
  'darkCurrentFiles': { schema: arraySchema(unionSchema([lazySchema(() => FilesFilterFileModelSchema), nullSchema])), optional: false },
  'maskFiles': { schema: arraySchema(unionSchema([lazySchema(() => FilesFilterFileModelSchema), nullSchema])), optional: false },
}))

export const AzimuthalIntegrationInputsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'xAxisUnit': { schema: unionSchema([literalSchema("2th_deg"), literalSchema("q_A^-1"), literalSchema("q_nm^-1")]), optional: false },
  'range': { schema: lazySchema(() => RangeModelSchema), optional: false },
  'numberOfPoints': { schema: numberSchema, optional: false },
  'azimuthalRange': { schema: lazySchema(() => RangeModelSchema), optional: false },
  'caking': { schema: booleanSchema, optional: false },
  'integration': { schema: booleanSchema, optional: false },
  'videoGeneration': { schema: booleanSchema, optional: false },
  'numberOfAzimuthalBins': { schema: numberSchema, optional: false },
  'imageOptions': { schema: lazySchema(() => ImageOptionsModelSchema), optional: false },
}))

export const AzimuthalIntegrationLookupDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'twoTheta': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'dSpace': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
}))

export const AzimuthalIntegrationLookupRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'mode': { schema: unionSchema([literalSchema("single"), literalSchema("combined")]), optional: false },
  'detectorFiles': { schema: arraySchema(stringSchema), optional: false },
  'calibrationFiles': { schema: arraySchema(stringSchema), optional: false },
  'point': { schema: lazySchema(() => XySchema), optional: false },
}))

export const AzimuthalIntegrationLookupResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => AzimuthalIntegrationLookupDataSchema), optional: false },
}))

export const AzimuthalIntegrationPreviewImageSizeSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'width': { schema: numberSchema, optional: false },
  'height': { schema: numberSchema, optional: false },
}))

export const AzimuthalIntegrationPreviewRangeModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'lower': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'upper': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
}))

export const AzimuthalIntegrationRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'userId': { schema: stringSchema, optional: false },
  'files': { schema: lazySchema(() => AzimuthalIntegrationFilesSchema), optional: false },
  'inputs': { schema: lazySchema(() => AzimuthalIntegrationInputsSchema), optional: false },
}))

export const AzimuthalIntegrationSignalDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'radial': { schema: arraySchema(numberSchema), optional: false },
  'intensity': { schema: arraySchema(numberSchema), optional: false },
}))

export const AzimuthalIntegrationSignalRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'mode': { schema: unionSchema([literalSchema("single"), literalSchema("combined")]), optional: false },
  'detectorFiles': { schema: arraySchema(stringSchema), optional: false },
  'calibrationFiles': { schema: arraySchema(stringSchema), optional: false },
  'radialRange': { schema: lazySchema(() => AzimuthalIntegrationPreviewRangeModelSchema), optional: false },
  'azimuthalRange': { schema: lazySchema(() => RangeModelSchema), optional: false },
  'numberOfPoints': { schema: numberSchema, optional: true },
}))

export const AzimuthalIntegrationSignalResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => AzimuthalIntegrationSignalDataSchema), optional: false },
}))

export const AzimuthalRangeSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'start': { schema: numberSchema, optional: false },
  'end': { schema: numberSchema, optional: false },
}))

export const BaselineModelSchema: RuntimeSchema = lazySchema(() => unionSchema([lazySchema(() => ArPlsBaselineModelSchema), lazySchema(() => LinearBaselineModelSchema), lazySchema(() => PolynomialBaselineModelSchema), lazySchema(() => SplineBaselineModelSchema)]))

export const BiaxialModeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("off"), literalSchema("yyEqualsXx"), literalSchema("yyEqualsZz")]))

export const CalculationDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'background': { schema: lazySchema(() => DataXySchema), optional: false },
  'calculations': { schema: lazySchema(() => DataXySchema), optional: false },
  'residual': { schema: lazySchema(() => DataXySchema), optional: false },
}))

export const CallbackCakingDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'radial': { schema: arraySchema(numberSchema), optional: false },
  'traces': { schema: recordSchema(lazySchema(() => CallbackCakingTraceSchema)), optional: false },
  'selectedRange': { schema: stringSchema, optional: false },
}))

export const CallbackCakingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'index': { schema: stringSchema, optional: false },
  'cakingRange': { schema: stringSchema, optional: false },
}))

export const CallbackCakingResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackCakingDataSchema), optional: false },
}))

export const CallbackCakingTraceSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'intensity': { schema: arraySchema(numberSchema), optional: false },
}))

export const CallbackDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'ringData': { schema: lazySchema(() => DetectorRingDataSchema), optional: false },
  'poniData': { schema: lazySchema(() => PoniFileDataSchema), optional: false },
  'startingRingNumber': { schema: numberSchema, optional: false },
  'ringImage': { schema: stringSchema, optional: false },
}))

export const CallbackDensityDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'densityData': { schema: lazySchema(() => DislocationDensityAblineSchema), optional: false },
}))

export const CallbackDensityRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
}))

export const CallbackDensityResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackDensityDataSchema), optional: false },
}))

export const CallbackEssDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'estimateSubgrainSizeData': { schema: lazySchema(() => DislocationDensityAblineSchema), optional: false },
  'densityPickerData': { schema: lazySchema(() => DislocationDensityRhoPickerDataSchema), optional: false },
}))

export const CallbackEssRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
}))

export const CallbackEssResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackEssDataSchema), optional: false },
}))

export const CallbackFittingCallbackFittingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
}))

export const CallbackFittingCallbackFittingResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => PeakFittingPartitionFittingDataFileSchema), optional: false },
}))

export const CallbackFittingDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'fittedData': { schema: lazySchema(() => PeakFittingPartitionFittingDataFileSchema), optional: false },
}))

export const CallbackFittingInstrumentalResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: unionSchema([lazySchema(() => InstrumentalFileCreationFittingSchema), nullSchema]), optional: false },
}))

export const CallbackFittingLeBailResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: unionSchema([lazySchema(() => CalculationDataSchema), nullSchema]), optional: false },
}))

export const CallbackFittingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
}))

export const CallbackFittingResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackFittingDataSchema), optional: false },
}))

export const CallbackFittingRietveldResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: unionSchema([lazySchema(() => RietveldFittingDataSchema), nullSchema]), optional: false },
}))

export const CallbackImagesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'urls': { schema: arraySchema(stringSchema), optional: false },
}))

export const CallbackImagesRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const CallbackImagesResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackImagesSchema), optional: false },
}))

export const CallbackIntegrationDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'radial': { schema: arraySchema(numberSchema), optional: false },
  'traces': { schema: recordSchema(lazySchema(() => CallbackIntegrationTraceSchema)), optional: false },
  'selectedIndexes': { schema: stringSchema, optional: false },
}))

export const CallbackIntegrationRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'indexes': { schema: stringSchema, optional: false },
}))

export const CallbackIntegrationResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackIntegrationDataSchema), optional: false },
}))

export const CallbackIntegrationTraceSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'intensity': { schema: arraySchema(numberSchema), optional: false },
}))

export const CallbackMaskCreatorStateDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'maskCreator': { schema: unionSchema([lazySchema(() => MaskCreatorStateSchema), nullSchema]), optional: true },
  'artifactDownloads': { schema: recordSchema(stringSchema), optional: true },
}))

export const CallbackMaskCreatorStateRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'analysisType': { schema: unionSchema([literalSchema("dislocationDensity"), literalSchema("peakFitting"), literalSchema("phaseQuantification"), literalSchema("stressStrain")]), optional: false },
}))

export const CallbackMaskCreatorStateResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackMaskCreatorStateDataSchema), optional: false },
}))

export const CallbackMaskPreviewDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'mask': { schema: arraySchema(arraySchema(numberSchema)), optional: false },
}))

export const CallbackMaskPreviewRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'maskFile': { schema: lazySchema(() => FilesFilterFileModelSchema), optional: false },
}))

export const CallbackMaskPreviewResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackMaskPreviewDataSchema), optional: false },
}))

export const CallbackMwhDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'mwhData': { schema: arraySchema(lazySchema(() => DislocationDensityK2cLnaSchema)), optional: false },
  'k2cDkPlot': { schema: arraySchema(lazySchema(() => DislocationDensityK2cDkSchema)), optional: false },
  'estimateSubgrainSizePickerData': { schema: lazySchema(() => DislocationDensityLn0PickerSchema), optional: false },
}))

export const CallbackMwhRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
}))

export const CallbackMwhResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackMwhDataSchema), optional: false },
}))

export const CallbackParametersCallbackParametersDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'parametersData': { schema: lazySchema(() => PeakFittingFittingModelSchema), optional: false },
  'debyeWallerParameters': { schema: lazySchema(() => DebyeWallerParametersSchema), optional: false },
}))

export const CallbackParametersCallbackParametersRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const CallbackParametersCallbackParametersResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => InstrumentalFileCreationDataFilePhasesSchema), optional: false },
}))

export const CallbackParametersDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'resultFiles': { schema: lazySchema(() => ParametersGroupingSchema), optional: false },
  'peakFittingParameters': { schema: lazySchema(() => PeakFittingFittingModelSchema), optional: false },
  'whParameters': { schema: lazySchema(() => DislocationDensityWhParametersSchema), optional: false },
  'mwhParameters': { schema: lazySchema(() => DislocationDensityMwhParametersSchema), optional: false },
  'subgrainSizeEstimateParameters': { schema: lazySchema(() => DislocationDensitySubgrainSizeEstimationDataSchema), optional: false },
  'densityParameters': { schema: lazySchema(() => DislocationDensityDensityDataSchema), optional: false },
}))

export const CallbackParametersRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataFiles': { schema: arraySchema(stringSchema), optional: true },
}))

export const CallbackParametersResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackParametersDataSchema), optional: false },
}))

export const CallbackReportCallbackReportRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'columnKey': { schema: stringSchema, optional: false },
}))

export const CallbackReportCallbackReportResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackReportReportColumnPayloadSchema), optional: false },
}))

export const CallbackReportMetaCallbackReportMetaRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const CallbackReportMetaCallbackReportMetaResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackReportMetaReportMetaPayloadSchema), optional: false },
}))

export const CallbackReportMetaReportMetaPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'rowKeys': { schema: arraySchema(stringSchema), optional: false },
  'columnSchema': { schema: arraySchema(stringSchema), optional: false },
  'mask': { schema: unionSchema([arraySchema(booleanSchema), nullSchema]), optional: true },
  'rsquaredByPartition': { schema: unionSchema([recordSchema(arraySchema(unionSchema([numberSchema, nullSchema]))), nullSchema]), optional: true },
  'columnPartitions': { schema: unionSchema([recordSchema(numberSchema), nullSchema]), optional: true },
}))

export const CallbackReportMetaReportMetricDefinitionSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'key': { schema: stringSchema, optional: false },
  'label': { schema: stringSchema, optional: false },
  'group': { schema: stringSchema, optional: false },
  'unit': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'hasUncertainty': { schema: booleanSchema, optional: false },
}))

export const CallbackReportMetaRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const CallbackReportMetaResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ReportMetaPayloadSchema), optional: false },
}))

export const CallbackReportReportColumnPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'columnKey': { schema: stringSchema, optional: false },
  'values': { schema: arraySchema(unionSchema([numberSchema, nullSchema])), optional: false },
}))

export const CallbackReportRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'columnKey': { schema: stringSchema, optional: false },
}))

export const CallbackReportResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ReportColumnPayloadSchema), optional: false },
}))

export const CallbackRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const CallbackResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackDataSchema), optional: false },
}))

export const CallbackStressRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'startIndex': { schema: numberSchema, optional: false },
  'limit': { schema: numberSchema, optional: false },
}))

export const CallbackStressResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => StressParametersSchema), optional: false },
}))

export const CallbackWhDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'whData': { schema: lazySchema(() => DislocationDensityWhSchema), optional: false },
}))

export const CallbackWhRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
}))

export const CallbackWhResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackWhDataSchema), optional: false },
}))

export const CifAbcValueRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'cifFile': { schema: stringSchema, optional: false },
}))

export const CifAbcValueResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CifValuesSchema), optional: false },
}))

export const CifAbcValuesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'a': { schema: numberSchema, optional: false },
  'b': { schema: numberSchema, optional: false },
  'c': { schema: numberSchema, optional: false },
}))

export const CifSameValuesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'ab': { schema: booleanSchema, optional: true },
  'ac': { schema: booleanSchema, optional: true },
  'bc': { schema: booleanSchema, optional: true },
}))

export const CifValuesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'abcValues': { schema: lazySchema(() => CifAbcValuesSchema), optional: false },
  'sameValues': { schema: lazySchema(() => CifSameValuesSchema), optional: false },
}))

export const ColormapTypeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("magma"), literalSchema("inferno"), literalSchema("plasma"), literalSchema("viridis"), literalSchema("cividis"), literalSchema("twilight"), literalSchema("twilight_shifted"), literalSchema("turbo"), literalSchema("berlin"), literalSchema("managua"), literalSchema("vanimo"), literalSchema("Blues"), literalSchema("BrBG"), literalSchema("BuGn"), literalSchema("BuPu"), literalSchema("CMRmap"), literalSchema("GnBu"), literalSchema("Greens"), literalSchema("Greys"), literalSchema("OrRd"), literalSchema("Oranges"), literalSchema("PRGn"), literalSchema("PiYG"), literalSchema("PuBu"), literalSchema("PuBuGn"), literalSchema("PuOr"), literalSchema("PuRd"), literalSchema("Purples"), literalSchema("RdBu"), literalSchema("RdGy"), literalSchema("RdPu"), literalSchema("RdYlBu"), literalSchema("RdYlGn"), literalSchema("Reds"), literalSchema("Spectral"), literalSchema("Wistia"), literalSchema("YlGn"), literalSchema("YlGnBu"), literalSchema("YlOrBr"), literalSchema("YlOrRd"), literalSchema("afmhot"), literalSchema("autumn"), literalSchema("binary"), literalSchema("bone"), literalSchema("brg"), literalSchema("bwr"), literalSchema("cool"), literalSchema("coolwarm"), literalSchema("copper"), literalSchema("cubehelix"), literalSchema("flag"), literalSchema("gist_earth"), literalSchema("gist_gray"), literalSchema("gist_heat"), literalSchema("gist_ncar"), literalSchema("gist_rainbow"), literalSchema("gist_stern"), literalSchema("gist_yarg"), literalSchema("gnuplot"), literalSchema("gnuplot2"), literalSchema("gray"), literalSchema("hot"), literalSchema("hsv"), literalSchema("jet"), literalSchema("nipy_spectral"), literalSchema("ocean"), literalSchema("pink"), literalSchema("prism"), literalSchema("rainbow"), literalSchema("seismic"), literalSchema("spring"), literalSchema("summer"), literalSchema("terrain"), literalSchema("winter"), literalSchema("Accent"), literalSchema("Dark2"), literalSchema("Paired"), literalSchema("Pastel1"), literalSchema("Pastel2"), literalSchema("Set1"), literalSchema("Set2"), literalSchema("Set3"), literalSchema("tab10"), literalSchema("tab20"), literalSchema("tab20b"), literalSchema("tab20c"), literalSchema("grey"), literalSchema("gist_grey"), literalSchema("gist_yerg"), literalSchema("Grays"), literalSchema("magma_r"), literalSchema("inferno_r"), literalSchema("plasma_r"), literalSchema("viridis_r"), literalSchema("cividis_r"), literalSchema("twilight_r"), literalSchema("twilight_shifted_r"), literalSchema("turbo_r"), literalSchema("berlin_r"), literalSchema("managua_r"), literalSchema("vanimo_r"), literalSchema("Blues_r"), literalSchema("BrBG_r"), literalSchema("BuGn_r"), literalSchema("BuPu_r"), literalSchema("CMRmap_r"), literalSchema("GnBu_r"), literalSchema("Greens_r"), literalSchema("Greys_r"), literalSchema("OrRd_r"), literalSchema("Oranges_r"), literalSchema("PRGn_r"), literalSchema("PiYG_r"), literalSchema("PuBu_r"), literalSchema("PuBuGn_r"), literalSchema("PuOr_r"), literalSchema("PuRd_r"), literalSchema("Purples_r"), literalSchema("RdBu_r"), literalSchema("RdGy_r"), literalSchema("RdPu_r"), literalSchema("RdYlBu_r"), literalSchema("RdYlGn_r"), literalSchema("Reds_r"), literalSchema("Spectral_r"), literalSchema("Wistia_r"), literalSchema("YlGn_r"), literalSchema("YlGnBu_r"), literalSchema("YlOrBr_r"), literalSchema("YlOrRd_r"), literalSchema("afmhot_r"), literalSchema("autumn_r"), literalSchema("binary_r"), literalSchema("bone_r"), literalSchema("brg_r"), literalSchema("bwr_r"), literalSchema("cool_r"), literalSchema("coolwarm_r"), literalSchema("copper_r"), literalSchema("cubehelix_r"), literalSchema("flag_r"), literalSchema("gist_earth_r"), literalSchema("gist_gray_r"), literalSchema("gist_heat_r"), literalSchema("gist_ncar_r"), literalSchema("gist_rainbow_r"), literalSchema("gist_stern_r"), literalSchema("gist_yarg_r"), literalSchema("gnuplot_r"), literalSchema("gnuplot2_r"), literalSchema("gray_r"), literalSchema("hot_r"), literalSchema("hsv_r"), literalSchema("jet_r"), literalSchema("nipy_spectral_r"), literalSchema("ocean_r"), literalSchema("pink_r"), literalSchema("prism_r"), literalSchema("rainbow_r"), literalSchema("seismic_r"), literalSchema("spring_r"), literalSchema("summer_r"), literalSchema("terrain_r"), literalSchema("winter_r"), literalSchema("Accent_r"), literalSchema("Dark2_r"), literalSchema("Paired_r"), literalSchema("Pastel1_r"), literalSchema("Pastel2_r"), literalSchema("Set1_r"), literalSchema("Set2_r"), literalSchema("Set3_r"), literalSchema("tab10_r"), literalSchema("tab20_r"), literalSchema("tab20b_r"), literalSchema("tab20c_r"), literalSchema("grey_r"), literalSchema("gist_grey_r"), literalSchema("gist_yerg_r"), literalSchema("Grays_r")]))

export const ComponentsCurvesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'pseudoVoigt': { schema: arraySchema(lazySchema(() => CurveSchema)), optional: false },
  'gaussian': { schema: arraySchema(lazySchema(() => CurveSchema)), optional: false },
  'lorentzian': { schema: arraySchema(lazySchema(() => CurveSchema)), optional: false },
  'pearson7': { schema: arraySchema(lazySchema(() => CurveSchema)), optional: false },
}))

export const CoordinateSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'y': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
}))

export const CoordinateIntRequiredSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: numberSchema, optional: false },
  'y': { schema: numberSchema, optional: false },
}))

export const CoordinateRequiredSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: numberSchema, optional: false },
  'y': { schema: numberSchema, optional: false },
}))

export const CopyProjectRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sourceProjectId': { schema: stringSchema, optional: false },
}))

export const CopyProjectResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ProjectSchema), optional: false },
}))

export const CreateFolderRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'folderName': { schema: stringSchema, optional: false },
  'parentPath': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const CreateFolderResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => FolderSchema), optional: false },
}))

export const CreateProjectInviteDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'token': { schema: stringSchema, optional: false },
  'expiresInSeconds': { schema: numberSchema, optional: false },
}))

export const CreateProjectInviteRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const CreateProjectInviteResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CreateProjectInviteDataSchema), optional: false },
}))

export const CreateProjectRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectName': { schema: stringSchema, optional: false },
  'path': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const CreateProjectResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ProjectSchema), optional: false },
}))

export const CreateReportGraphTemplateRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'name': { schema: stringSchema, optional: false },
  'settings': { schema: recordSchema(unknownSchema), optional: false },
}))

export const CreateReportGraphTemplateResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => GraphTemplateSchema), optional: false },
}))

export const CurveSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'y': { schema: arraySchema(numberSchema), optional: false },
}))

export const DataCalibrationAddRingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'userId': { schema: stringSchema, optional: false },
  'coordinate': { schema: lazySchema(() => CoordinateRequiredSchema), optional: false },
  'imageTransformation': { schema: lazySchema(() => ImageTransformationSchema), optional: false },
  'detectorConfiguration': { schema: lazySchema(() => DetectorConfigurationSchema), optional: false },
  'detectorImageConfig': { schema: lazySchema(() => DetectorImageConfigSchema), optional: false },
}))

export const DataCalibrationMaskingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'userId': { schema: stringSchema, optional: false },
  'projectId': { schema: stringSchema, optional: false },
  'imageTransformation': { schema: lazySchema(() => ImageTransformationSchema), optional: false },
  'detectorConfiguration': { schema: lazySchema(() => DetectorConfigurationSchema), optional: false },
  'detectorImage': { schema: lazySchema(() => DetectorImageConfigSchema), optional: false },
  'detectorIndex': { schema: numberSchema, optional: false },
}))

export const DataCalibrationRemoveRingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'userId': { schema: stringSchema, optional: false },
  'coordinate': { schema: lazySchema(() => CoordinateRequiredSchema), optional: false },
  'imageTransformation': { schema: lazySchema(() => ImageTransformationSchema), optional: false },
  'detectorConfiguration': { schema: lazySchema(() => DetectorConfigurationSchema), optional: false },
  'detectorImageConfig': { schema: lazySchema(() => DetectorImageConfigSchema), optional: false },
}))

export const DataCalibrationRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'userId': { schema: stringSchema, optional: false },
  'projectId': { schema: stringSchema, optional: false },
  'detectorImages': { schema: arraySchema(lazySchema(() => DetectorImageConfigSchema)), optional: false },
  'imageTransformation': { schema: lazySchema(() => ImageTransformationSchema), optional: false },
  'detectorConfiguration': { schema: lazySchema(() => DetectorConfigurationSchema), optional: false },
}))

export const DataFilePhaseCifSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => PhaseCifSchema)))

export const DataObjectSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'peakFitting': { schema: lazySchema(() => PeakFittingFittingModelSchema), optional: false },
  'stressFitting': { schema: lazySchema(() => StressFittingSchema), optional: false },
  'stressParameters': { schema: lazySchema(() => StressParametersSchema), optional: false },
}))

export const DataXySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: arraySchema(numberSchema), optional: false },
  'y': { schema: arraySchema(numberSchema), optional: false },
}))

export const DebyeWallerCifSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => ValueUncertaintySchema)))

export const DebyeWallerModeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("single"), literalSchema("perFile")]))

export const DebyeWallerParametersSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => DebyeWallerCifSchema)))

export const DeleteFileDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'deleted': { schema: arraySchema(stringSchema), optional: false },
  'errors': { schema: arraySchema(lazySchema(() => DeleteFileErrorSchema)), optional: false },
}))

export const DeleteFileErrorSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'key': { schema: stringSchema, optional: false },
  'code': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'message': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const DeleteFileRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'path': { schema: stringSchema, optional: false },
}))

export const DeleteFileResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => DeleteFileDataSchema), optional: false },
}))

export const DeleteFolderRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'folderId': { schema: stringSchema, optional: false },
  'force': { schema: booleanSchema, optional: true },
}))

export const DeleteFolderResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'success': { schema: booleanSchema, optional: false },
  'message': { schema: stringSchema, optional: false },
  'deletedFolderIds': { schema: arraySchema(stringSchema), optional: false },
  'archivedProjects': { schema: arraySchema(lazySchema(() => ProjectSchema)), optional: false },
}))

export const DeleteProjectRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const DeleteProjectResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: stringSchema, optional: false },
  'project': { schema: lazySchema(() => ProjectSchema), optional: false },
}))

export const DeleteReportGraphTemplateDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'success': { schema: booleanSchema, optional: false },
}))

export const DeleteReportGraphTemplateRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'templateId': { schema: stringSchema, optional: false },
}))

export const DeleteReportGraphTemplateResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => DeleteReportGraphTemplateDataSchema), optional: false },
}))

export const DetectorConfigExtraSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'pixel1': { schema: numberSchema, optional: false },
  'pixel2': { schema: numberSchema, optional: false },
  'maxShape': { schema: arraySchema(numberSchema), optional: false },
  'orientation': { schema: numberSchema, optional: false },
}))

export const DetectorConfigurationSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'calibrantType': { schema: stringSchema, optional: false },
  'detectorType': { schema: stringSchema, optional: false },
  'detectorSize': { schema: lazySchema(() => CoordinateSchema), optional: false },
  'detectorPixelSize': { schema: lazySchema(() => CoordinateSchema), optional: false },
  'wavelength': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'customDetector': { schema: booleanSchema, optional: false },
  'metaFile': { schema: stringSchema, optional: false },
  'quantile': { schema: numberSchema, optional: false },
  'startingRing': { schema: numberSchema, optional: false },
}))

export const DetectorDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'url': { schema: stringSchema, optional: false },
}))

export const DetectorImageConfigSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'detectorFile': { schema: lazySchema(() => FilesFilterFileModelSchema), optional: false },
  'masking': { schema: lazySchema(() => MaskingSchema), optional: false },
}))

export const DetectorRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'dataFile': { schema: lazySchema(() => FilesFilterFileModelSchema), optional: false },
  'imageTransformation': { schema: lazySchema(() => ImageTransformationSchema), optional: false },
  'projectId': { schema: stringSchema, optional: false },
}))

export const DetectorResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => DetectorDataSchema), optional: false },
}))

export const DetectorRingDataSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => RingSchema)))

export const DetectorSizeDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: numberSchema, optional: false },
  'y': { schema: numberSchema, optional: false },
}))

export const DetectorSizeRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataFile': { schema: lazySchema(() => FilesFilterFileModelSchema), optional: false },
}))

export const DetectorSizeResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => DetectorSizeDataSchema), optional: false },
}))

export const DislocationDensityAblineSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'ablineX': { schema: arraySchema(numberSchema), optional: false },
  'ablineY': { schema: arraySchema(numberSchema), optional: false },
  'x': { schema: arraySchema(numberSchema), optional: false },
  'y': { schema: arraySchema(numberSchema), optional: false },
}))

export const DislocationDensityDensitySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'rhoSlopes': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'rhoIntercepts': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'rho': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'rE': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'm': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
}))

export const DislocationDensityDensityDataSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => DislocationDensityDensitySchema)))

export const DislocationDensityInputsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'peakFitting': { schema: lazySchema(() => PeakFittingInputsModelSchema), optional: false },
  'ch00': { schema: numberSchema, optional: false },
  'tth1': { schema: numberSchema, optional: false },
  'tth2': { schema: numberSchema, optional: false },
  'ln': { schema: numberSchema, optional: false },
  'l0': { schema: tupleSchema([numberSchema, numberSchema]), optional: false },
  'rho': { schema: tupleSchema([numberSchema, numberSchema]), optional: false },
}))

export const DislocationDensityK2cDkSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'k2c': { schema: arraySchema(numberSchema), optional: false },
  'deltaDk': { schema: arraySchema(numberSchema), optional: false },
}))

export const DislocationDensityK2cLnaSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'k2c': { schema: arraySchema(numberSchema), optional: false },
  'lna': { schema: arraySchema(numberSchema), optional: false },
  'x': { schema: arraySchema(numberSchema), optional: false },
  'y': { schema: arraySchema(numberSchema), optional: false },
}))

export const DislocationDensityLn0PickerSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: arraySchema(numberSchema), optional: false },
  'y': { schema: arraySchema(numberSchema), optional: false },
}))

export const DislocationDensityMwhIndividualSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'breadths': { schema: arraySchema(lazySchema(() => ValueUncertaintySchema)), optional: false },
  'deltaK': { schema: arraySchema(lazySchema(() => ValueUncertaintySchema)), optional: false },
  'x': { schema: arraySchema(lazySchema(() => ValueUncertaintySchema)), optional: false },
  'c': { schema: arraySchema(lazySchema(() => ValueUncertaintySchema)), optional: false },
  'k2c': { schema: arraySchema(lazySchema(() => ValueUncertaintySchema)), optional: false },
  'lnA': { schema: arraySchema(arraySchema(lazySchema(() => ValueUncertaintySchema))), optional: false },
  'parabolicParams': { schema: arraySchema(arraySchema(unionSchema([numberSchema, nullSchema]))), optional: false },
  'alpha': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'q': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
}))

export const DislocationDensityMwhParametersSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => DislocationDensityMwhIndividualSchema)))

export const DislocationDensityRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'userId': { schema: stringSchema, optional: false },
  'files': { schema: lazySchema(() => FilesAnalysisModelSingleSchema), optional: false },
  'inputs': { schema: lazySchema(() => DislocationDensityInputsSchema), optional: false },
  'maskCreator': { schema: unionSchema([lazySchema(() => MaskCreatorStateSchema), nullSchema]), optional: true },
}))

export const DislocationDensityRhoPickerDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: arraySchema(numberSchema), optional: false },
  'y': { schema: arraySchema(numberSchema), optional: false },
}))

export const DislocationDensitySubgrainSizeEstimationSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'l0': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'l0Intercept': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'l0Slope': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
}))

export const DislocationDensitySubgrainSizeEstimationDataSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => DislocationDensitySubgrainSizeEstimationSchema)))

export const DislocationDensityWhSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: arraySchema(numberSchema), optional: false },
  'y': { schema: arraySchema(numberSchema), optional: false },
  'fit': { schema: arraySchema(numberSchema), optional: false },
}))

export const DislocationDensityWhIndividualSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'slope': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'strain': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'intercept': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'crystalliteSize': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'rho': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
}))

export const DislocationDensityWhParametersSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => DislocationDensityWhIndividualSchema)))

export const DownloadDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'url': { schema: stringSchema, optional: false },
}))

export const DownloadRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'callerType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
  'projectId': { schema: stringSchema, optional: false },
}))

export const DownloadResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => DownloadDataSchema), optional: false },
}))

export const DrawingIndividualSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'type': { schema: unionSchema([literalSchema("freeHand"), literalSchema("rectangle"), literalSchema("ellipse"), literalSchema("polygon")]), optional: false },
  'visible': { schema: booleanSchema, optional: false },
  'coordinates': { schema: arraySchema(lazySchema(() => CoordinateRequiredSchema)), optional: false },
}))

export const EcsStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("NO_INSTANCES"), literalSchema("STOPPING"), literalSchema("RUNNING"), literalSchema("STOPPED"), literalSchema("STARTING")]))

export const FilesAnalysisModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'dataFiles': { schema: arraySchema(lazySchema(() => FilesFilterModelSchema)), optional: false },
  'selectionFilters': { schema: lazySchema(() => SelectionFiltersModelSchema), optional: false },
  'cifFiles': { schema: arraySchema(lazySchema(() => FilesFilterFileModelSchema)), optional: false },
  'cifFilesABC': { schema: recordSchema(lazySchema(() => AbcSchema)), optional: false },
  'instrumentalFile': { schema: lazySchema(() => FilesFilterFileModelSchema), optional: false },
  'wavelength': { schema: lazySchema(() => PeakFittingWavelengthSchema), optional: false },
  'maskFile': { schema: unionSchema([lazySchema(() => FilesFilterFileModelSchema), nullSchema]), optional: true },
}))

export const FilesAnalysisModelSingleSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'dataFiles': { schema: arraySchema(lazySchema(() => FilesFilterModelSchema)), optional: false },
  'selectionFilters': { schema: lazySchema(() => SelectionFiltersModelSchema), optional: false },
  'cifFile': { schema: lazySchema(() => FilesFilterFileModelSchema), optional: false },
  'cifFilesABC': { schema: recordSchema(lazySchema(() => AbcSchema)), optional: false },
  'instrumentalFile': { schema: lazySchema(() => FilesFilterFileModelSchema), optional: false },
  'wavelength': { schema: lazySchema(() => PeakFittingWavelengthSchema), optional: false },
  'maskFile': { schema: unionSchema([lazySchema(() => FilesFilterFileModelSchema), nullSchema]), optional: true },
}))

export const FilesFilterFileModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'type': { schema: unionSchema([literalSchema("file")]), optional: false },
  'name': { schema: stringSchema, optional: false },
}))

export const FilesFilterFilteredFolderModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'type': { schema: unionSchema([literalSchema("filteredFolder")]), optional: false },
  'name': { schema: stringSchema, optional: false },
  'extension': { schema: arraySchema(stringSchema), optional: false },
  'query': { schema: stringSchema, optional: false },
  'matchMode': { schema: unionSchema([literalSchema("contains"), literalSchema("prefix"), literalSchema("range")]), optional: true },
  'ignoredPaths': { schema: arraySchema(stringSchema), optional: false },
}))

export const FilesFilterFolderModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'type': { schema: unionSchema([literalSchema("folder")]), optional: false },
  'name': { schema: stringSchema, optional: false },
  'extension': { schema: arraySchema(stringSchema), optional: false },
  'ignoredPaths': { schema: arraySchema(stringSchema), optional: false },
}))

export const FilesFilterModelSchema: RuntimeSchema = lazySchema(() => unionSchema([lazySchema(() => FilesFilterFileModelSchema), lazySchema(() => FilesFilterFolderModelSchema), lazySchema(() => FilesFilterFilteredFolderModelSchema)]))

export const FilterGroupSchema: RuntimeSchema = lazySchema(() => arraySchema(lazySchema(() => FilterItemSchema)))

export const FilterItemSchema: RuntimeSchema = lazySchema(() => unionSchema([unionSchema([lazySchema(() => FilesFilterFileModelSchema), lazySchema(() => FilesFilterFolderModelSchema)]), lazySchema(() => FilesFilterFilteredFolderModelSchema)]))

export const FolderSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'folderId': { schema: stringSchema, optional: false },
  'folderName': { schema: stringSchema, optional: false },
  'path': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'createdAt': { schema: stringSchema, optional: false },
}))

export const FrontendRumEventSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'eventId': { schema: stringSchema, optional: true },
  'eventType': { schema: lazySchema(() => ObservabilityRumEventTypeSchema), optional: false },
  'environment': { schema: lazySchema(() => ObservabilityEnvironmentSchema), optional: false },
  'observedAt': { schema: stringSchema, optional: false },
  'sessionId': { schema: stringSchema, optional: true },
  'userId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'route': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'browserContext': { schema: lazySchema(() => RumBrowserContextSchema), optional: true },
  'sessionStartedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'sessionEndedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'referrer': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'fromRoute': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'toRoute': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'durationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'loadDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'errorType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'message': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'fingerprint': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'stackHash': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'metricName': { schema: unionSchema([lazySchema(() => RumWebVitalNameSchema), nullSchema]), optional: true },
  'value': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'unit': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'rating': { schema: unionSchema([lazySchema(() => RumWebVitalRatingSchema), nullSchema]), optional: true },
  'outcomeName': { schema: unionSchema([lazySchema(() => ObservabilityProductOutcomeNameSchema), nullSchema]), optional: true },
  'projectId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'runId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'analysisType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'attributes': { schema: recordSchema(unknownSchema), optional: true },
}))

export const FrontendRumIngestionRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'events': { schema: arraySchema(lazySchema(() => FrontendRumEventSchema)), optional: true },
}))

export const FrontendRumIngestionResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'acceptedEvents': { schema: numberSchema, optional: false },
  'publishedEvents': { schema: numberSchema, optional: false },
}))

export const GraphTemplateSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'userId': { schema: stringSchema, optional: false },
  'templateId': { schema: stringSchema, optional: false },
  'name': { schema: stringSchema, optional: false },
  'settings': { schema: recordSchema(unknownSchema), optional: false },
  'createdAt': { schema: stringSchema, optional: false },
  'updatedAt': { schema: stringSchema, optional: false },
}))

export const HeartbeatAcknowledgedEventSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
  'ping': { schema: stringSchema, optional: false },
}))

export const HistogramSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'phases': { schema: recordSchema(arraySchema(lazySchema(() => PhaseEntrySchema))), optional: false },
  'data': { schema: lazySchema(() => DataXySchema), optional: false },
}))

export const ImageOptionsModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'colorMap': { schema: lazySchema(() => ColormapTypeSchema), optional: false },
  'log': { schema: booleanSchema, optional: false },
}))

export const ImageTransformationSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'rotation': { schema: unionSchema([literalSchema(0), literalSchema(90), literalSchema(180), literalSchema(270)]), optional: false },
  'flipUD': { schema: booleanSchema, optional: false },
  'flipLR': { schema: booleanSchema, optional: false },
  'colorMap': { schema: lazySchema(() => ColormapTypeSchema), optional: false },
  'log': { schema: booleanSchema, optional: false },
}))

export const InstrumentalFileCreationCallbackReportMetaRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const InstrumentalFileCreationCallbackReportMetaResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => InstrumentalFileCreationReportMetaPayloadSchema), optional: false },
}))

export const InstrumentalFileCreationCallbackReportRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'columnKey': { schema: stringSchema, optional: false },
}))

export const InstrumentalFileCreationCallbackReportResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => InstrumentalFileCreationReportColumnPayloadSchema), optional: false },
}))

export const InstrumentalFileCreationDataFilePhasesSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => InstrumentalFileCreationPhasesSchema)))

export const InstrumentalFileCreationFittingSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'observed': { schema: lazySchema(() => DataXySchema), optional: false },
  'calculations': { schema: lazySchema(() => DataXySchema), optional: false },
  'background': { schema: lazySchema(() => DataXySchema), optional: false },
  'residual': { schema: lazySchema(() => DataXySchema), optional: false },
}))

export const InstrumentalFileCreationInputsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'crystalliteSize': { schema: numberSchema, optional: false },
  'microstrain': { schema: numberSchema, optional: false },
  'refinementRange': { schema: lazySchema(() => RangeModelSchema), optional: false },
}))

export const InstrumentalFileCreationPhasesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'lengthA': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'lengthB': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'lengthC': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'angleAlpha': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'angleBeta': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'angleGamma': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'volume': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
}))

export const InstrumentalFileCreationReportColumnPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'columnKey': { schema: stringSchema, optional: false },
  'values': { schema: arraySchema(unionSchema([numberSchema, nullSchema])), optional: false },
}))

export const InstrumentalFileCreationReportMetaPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'rowKeys': { schema: arraySchema(stringSchema), optional: false },
  'columnSchema': { schema: arraySchema(stringSchema), optional: false },
  'mask': { schema: unionSchema([arraySchema(booleanSchema), nullSchema]), optional: true },
  'rsquaredByPartition': { schema: unionSchema([recordSchema(arraySchema(unionSchema([numberSchema, nullSchema]))), nullSchema]), optional: true },
  'columnPartitions': { schema: unionSchema([recordSchema(numberSchema), nullSchema]), optional: true },
}))

export const InstrumentalFileCreationRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'userId': { schema: stringSchema, optional: false },
  'files': { schema: lazySchema(() => FilesAnalysisModelSingleSchema), optional: false },
  'inputs': { schema: lazySchema(() => InstrumentalFileCreationInputsSchema), optional: false },
}))

export const LambdaCacheRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'callerType': { schema: unionSchema([lazySchema(() => AnalysisMethodsSchema), unionSchema([literalSchema("full")])]), optional: false },
}))

export const LambdaCacheResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: stringSchema, optional: false },
}))

export const LeBailInputsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'refinementRange': { schema: lazySchema(() => RangeModelSchema), optional: false },
}))

export const LeBailRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'userId': { schema: stringSchema, optional: false },
  'files': { schema: lazySchema(() => FilesAnalysisModelSchema), optional: false },
  'inputs': { schema: lazySchema(() => LeBailInputsSchema), optional: false },
}))

export const LinearBaselineModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'baselineFunction': { schema: unionSchema([literalSchema("linear")]), optional: false },
}))

export const ListFilesDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'files': { schema: arraySchema(stringSchema), optional: false },
  'folders': { schema: arraySchema(stringSchema), optional: false },
  'truncated': { schema: booleanSchema, optional: false },
  'nextContinuationToken': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ListFilesRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'path': { schema: stringSchema, optional: true },
  'extensions': { schema: unionSchema([arraySchema(stringSchema), nullSchema]), optional: true },
  'continuationToken': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'query': { schema: stringSchema, optional: true },
  'matchMode': { schema: unionSchema([literalSchema("contains"), literalSchema("prefix"), literalSchema("range")]), optional: true },
}))

export const ListFilesResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ListFilesDataSchema), optional: false },
}))

export const ListProjectMembersRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const ListProjectMembersResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: arraySchema(lazySchema(() => ProjectMemberSchema)), optional: false },
}))

export const ListSelectedFilesGroupedFilterGroupSchema: RuntimeSchema = lazySchema(() => arraySchema(lazySchema(() => ListSelectedFilesGroupedFilterItemSchema)))

export const ListSelectedFilesGroupedFilterItemSchema: RuntimeSchema = lazySchema(() => unionSchema([unionSchema([lazySchema(() => FilesFilterFileModelSchema), lazySchema(() => FilesFilterFolderModelSchema)]), lazySchema(() => FilesFilterFilteredFolderModelSchema)]))

export const ListSelectedFilesGroupedPaginationSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'nextContinuationToken': { schema: unionSchema([stringSchema, nullSchema]), optional: false },
  'filtering': { schema: unionSchema([stringSchema, nullSchema]), optional: false },
}))

export const ListSelectedFilesGroupedRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'filters': { schema: arraySchema(lazySchema(() => ListSelectedFilesGroupedFilterGroupSchema)), optional: false },
  'length': { schema: numberSchema, optional: false },
  'pagination': { schema: arraySchema(lazySchema(() => ListSelectedFilesGroupedPaginationSchema)), optional: false },
}))

export const ListSelectedFilesGroupedResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: arraySchema(lazySchema(() => ListSelectedFilesGroupedResponseItemSchema)), optional: false },
}))

export const ListSelectedFilesGroupedResponseItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'files': { schema: arraySchema(stringSchema), optional: false },
  'nextContinuationToken': { schema: unionSchema([stringSchema, nullSchema]), optional: false },
  'filtering': { schema: unionSchema([stringSchema, nullSchema]), optional: false },
}))

export const ListSelectedFilesPaginationSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'nextContinuationToken': { schema: unionSchema([stringSchema, nullSchema]), optional: false },
  'filtering': { schema: unionSchema([stringSchema, nullSchema]), optional: false },
}))

export const ListSelectedFilesRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'filters': { schema: lazySchema(() => FilterGroupSchema), optional: false },
  'length': { schema: numberSchema, optional: false },
  'pagination': { schema: lazySchema(() => ListSelectedFilesPaginationSchema), optional: false },
}))

export const ListSelectedFilesResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ListSelectedFilesResponseItemSchema), optional: false },
}))

export const ListSelectedFilesResponseItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'files': { schema: arraySchema(stringSchema), optional: false },
  'nextContinuationToken': { schema: unionSchema([stringSchema, nullSchema]), optional: false },
  'filtering': { schema: unionSchema([stringSchema, nullSchema]), optional: false },
}))

export const ListSelectedMetaFilesRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'filters': { schema: arraySchema(lazySchema(() => FilesFilterFileModelSchema)), optional: false },
}))

export const ListSelectedMetaFilesResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: arraySchema(stringSchema), optional: false },
}))

export const MaskCreatorAnalysisTypeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("dislocationDensity"), literalSchema("peakFitting"), literalSchema("phaseQuantification"), literalSchema("stressStrain")]))

export const MaskCreatorBinningSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'enabled': { schema: booleanSchema, optional: true },
  'size': { schema: numberSchema, optional: true },
  'aggregation': { schema: unionSchema([literalSchema("average"), literalSchema("max")]), optional: true },
}))

export const MaskCreatorPartitionArtifactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'version': { schema: numberSchema, optional: false },
  'analysisType': { schema: lazySchema(() => MaskCreatorAnalysisTypeSchema), optional: false },
  'generatedAt': { schema: stringSchema, optional: false },
  'partitionKey': { schema: stringSchema, optional: false },
  'partitionIndex': { schema: numberSchema, optional: false },
  'range': { schema: lazySchema(() => RangeModelSchema), optional: false },
  'rowKeys': { schema: arraySchema(stringSchema), optional: false },
  'sourceKeys': { schema: arraySchema(stringSchema), optional: false },
  'intensityValues': { schema: arraySchema(unionSchema([numberSchema, nullSchema])), optional: false },
  'normalizedIntensityValues': { schema: arraySchema(unionSchema([numberSchema, nullSchema])), optional: false },
  'defaultThreshold': { schema: numberSchema, optional: false },
}))

export const MaskCreatorPartitionSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'partitionKey': { schema: stringSchema, optional: false },
  'partitionIndex': { schema: numberSchema, optional: false },
  'range': { schema: lazySchema(() => RangeModelSchema), optional: false },
  'artifactFile': { schema: stringSchema, optional: false },
  'minIntensity': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'maxIntensity': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'defaultThreshold': { schema: numberSchema, optional: false },
}))

export const MaskCreatorResultArtifactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'version': { schema: numberSchema, optional: false },
  'analysisType': { schema: lazySchema(() => MaskCreatorAnalysisTypeSchema), optional: false },
  'generatedAt': { schema: stringSchema, optional: false },
  'rowKeys': { schema: arraySchema(stringSchema), optional: false },
  'sourceKeys': { schema: arraySchema(stringSchema), optional: false },
  'intensityValues': { schema: arraySchema(unionSchema([numberSchema, nullSchema])), optional: false },
  'normalizedIntensityValues': { schema: arraySchema(unionSchema([numberSchema, nullSchema])), optional: false },
  'partitionKeys': { schema: arraySchema(stringSchema), optional: false },
}))

export const MaskCreatorScanOrderSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'horizontal': { schema: booleanSchema, optional: true },
  'startFromLeft': { schema: booleanSchema, optional: true },
  'startFromTop': { schema: booleanSchema, optional: true },
}))

export const MaskCreatorStateSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'version': { schema: numberSchema, optional: true },
  'status': { schema: unionSchema([literalSchema("idle"), literalSchema("preparing"), literalSchema("ready"), literalSchema("publishing"), literalSchema("published"), literalSchema("error")]), optional: true },
  'usePreparedMask': { schema: booleanSchema, optional: true },
  'summaryFile': { schema: unionSchema([lazySchema(() => FilesFilterFileModelSchema), nullSchema]), optional: true },
  'publishedMaskFile': { schema: unionSchema([lazySchema(() => FilesFilterFileModelSchema), nullSchema]), optional: true },
  'rawArtifactFiles': { schema: recordSchema(lazySchema(() => FilesFilterFileModelSchema)), optional: true },
  'rows': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'columns': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'scanOrder': { schema: lazySchema(() => MaskCreatorScanOrderSchema), optional: true },
  'binning': { schema: lazySchema(() => MaskCreatorBinningSchema), optional: true },
  'activeTab': { schema: stringSchema, optional: true },
  'partitionThresholds': { schema: recordSchema(numberSchema), optional: true },
  'partitionEnabled': { schema: recordSchema(booleanSchema), optional: true },
  'resultOpacity': { schema: numberSchema, optional: true },
  'editMode': { schema: unionSchema([literalSchema("paint"), literalSchema("remove")]), optional: true },
  'manualIncludedRowKeys': { schema: arraySchema(stringSchema), optional: true },
  'manualExcludedRowKeys': { schema: arraySchema(stringSchema), optional: true },
  'lastPreparedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'lastPublishedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const MaskCreatorSummaryArtifactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'version': { schema: numberSchema, optional: false },
  'analysisType': { schema: lazySchema(() => MaskCreatorAnalysisTypeSchema), optional: false },
  'generatedAt': { schema: stringSchema, optional: false },
  'rows': { schema: numberSchema, optional: false },
  'columns': { schema: numberSchema, optional: false },
  'scanOrder': { schema: lazySchema(() => MaskCreatorScanOrderSchema), optional: false },
  'rowKeys': { schema: arraySchema(stringSchema), optional: false },
  'sourceKeys': { schema: arraySchema(stringSchema), optional: false },
  'partitions': { schema: arraySchema(lazySchema(() => MaskCreatorPartitionSummarySchema)), optional: false },
  'resultArtifactFile': { schema: stringSchema, optional: false },
}))

export const MaskedRingSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: numberSchema, optional: false },
  'y': { schema: numberSchema, optional: false },
  'ringNumber': { schema: numberSchema, optional: false },
}))

export const MaskingSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'below': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'above': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'drawings': { schema: arraySchema(lazySchema(() => DrawingIndividualSchema)), optional: false },
}))

export const MaskingDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'url': { schema: stringSchema, optional: false },
}))

export const MaskingDownloadDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'name': { schema: stringSchema, optional: false },
  'url': { schema: stringSchema, optional: false },
}))

export const MaskingDownloadRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'detectorIndex': { schema: numberSchema, optional: false },
}))

export const MaskingDownloadResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => MaskingDownloadDataSchema), optional: false },
}))

export const MaskingResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => MaskingDataSchema), optional: false },
}))

export const MetaInfoSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'pilatusEnergySetting': { schema: numberSchema, optional: false },
  'threshold': { schema: numberSchema, optional: false },
  'psnap': { schema: stringSchema, optional: false },
}))

export const MoveFolderRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'folderId': { schema: stringSchema, optional: false },
  'destinationPath': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const MoveFolderResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => FolderSchema), optional: false },
}))

export const MoveProjectRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'destinationPath': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const MoveProjectResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ProjectSchema), optional: false },
}))

export const ObservabilityAcknowledgeFailureRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: lazySchema(() => ObservabilityEnvironmentSchema), optional: true },
  'failureId': { schema: stringSchema, optional: true },
}))

export const ObservabilityAcknowledgeFailureResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'item': { schema: lazySchema(() => ObservabilityFailureQueueItemSchema), optional: false },
}))

export const ObservabilityApiRequestFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'apiId': { schema: stringSchema, optional: false },
  'stage': { schema: stringSchema, optional: false },
  'routeKey': { schema: stringSchema, optional: false },
  'method': { schema: stringSchema, optional: false },
  'requestId': { schema: stringSchema, optional: false },
  'integrationRequestId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'observedAt': { schema: stringSchema, optional: false },
  'statusCode': { schema: numberSchema, optional: true },
  'responseLatencyMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'integrationLatencyMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'responseLengthBytes': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'serviceName': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityAppliedQueryFilterSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: lazySchema(() => ObservabilityEnvironmentSchema), optional: false },
  'startTime': { schema: stringSchema, optional: false },
  'endTime': { schema: stringSchema, optional: false },
  'analysisTypes': { schema: arraySchema(stringSchema), optional: true },
  'serviceNames': { schema: arraySchema(stringSchema), optional: true },
  'runtimeTypes': { schema: arraySchema(lazySchema(() => ObservabilityRuntimeTypeSchema)), optional: true },
  'sources': { schema: arraySchema(stringSchema), optional: true },
}))

export const ObservabilityBaseModelSchema: RuntimeSchema = lazySchema(() => objectSchema({

}))

export const ObservabilityBottleneckDiagnosticSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'analysisType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'spanName': { schema: stringSchema, optional: false },
  'observations': { schema: numberSchema, optional: true },
  'failedSpans': { schema: numberSchema, optional: true },
  'duration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'recordedStageTimeShare': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
}))

export const ObservabilityBulkFailureTransitionRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: lazySchema(() => ObservabilityEnvironmentSchema), optional: true },
  'failureIds': { schema: unionSchema([arraySchema(stringSchema), nullSchema]), optional: true },
  'groupKeys': { schema: unionSchema([arraySchema(stringSchema), nullSchema]), optional: true },
  'filter': { schema: unionSchema([lazySchema(() => ObservabilityQueryFilterSchema), nullSchema]), optional: true },
  'status': { schema: unionSchema([lazySchema(() => ObservabilityFailureQueueViewSchema), nullSchema]), optional: true },
  'action': { schema: lazySchema(() => ObservabilityFailureTransitionActionSchema), optional: false },
  'reason': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityBulkFailureTransitionResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'items': { schema: arraySchema(lazySchema(() => ObservabilityFailureQueueItemSchema)), optional: true },
  'errors': { schema: arraySchema(lazySchema(() => ObservabilityFailureTransitionErrorSchema)), optional: true },
  'updatedCount': { schema: numberSchema, optional: true },
}))

export const ObservabilityCatalogRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'limit': { schema: numberSchema, optional: true },
}))

export const ObservabilityCatalogResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'definitions': { schema: arraySchema(lazySchema(() => ObservabilityGovernedMetricDefinitionSchema)), optional: true },
  'spans': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'metricSamples': { schema: arraySchema(lazySchema(() => ObservabilityMetricDefinitionSchema)), optional: true },
  'rumWebVitals': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'runtimes': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'services': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'sources': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'analysisTypes': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'failureCategories': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
}))

export const ObservabilityCollectionComponentSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'key': { schema: stringSchema, optional: false },
  'label': { schema: stringSchema, optional: false },
  'status': { schema: lazySchema(() => ObservabilityCollectionStatusSchema), optional: false },
  'summary': { schema: stringSchema, optional: false },
  'observations': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'lastObservedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'lastReceivedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'owner': { schema: stringSchema, optional: false },
  'limitation': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'details': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilityCollectionStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("active"), literalSchema("degraded"), literalSchema("missing"), literalSchema("unknown")]))

export const ObservabilityCompareBucketSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'key': { schema: stringSchema, optional: false },
  'count': { schema: numberSchema, optional: true },
  'values': { schema: unionSchema([lazySchema(() => ObservabilityPercentilesSchema), nullSchema]), optional: true },
}))

export const ObservabilityCompareDimensionSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("analysis_type"), literalSchema("service_name"), literalSchema("runtime_type"), literalSchema("source"), literalSchema("job_kind"), literalSchema("status"), literalSchema("span_name"), literalSchema("metric_name"), literalSchema("metric_family"), literalSchema("route"), literalSchema("web_vital_name")]))

export const ObservabilityCompareMetricSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("runs"), literalSchema("failures"), literalSchema("run_duration"), literalSchema("startup_duration"), literalSchema("queue_wait_duration"), literalSchema("span_duration"), literalSchema("metric_sample_value"), literalSchema("page_load"), literalSchema("route_navigation"), literalSchema("web_vital_value"), literalSchema("client_errors")]))

export const ObservabilityCompareRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'metric': { schema: lazySchema(() => ObservabilityCompareMetricSchema), optional: true },
  'dimension': { schema: lazySchema(() => ObservabilityCompareDimensionSchema), optional: true },
  'limit': { schema: numberSchema, optional: true },
}))

export const ObservabilityCompareResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'metric': { schema: lazySchema(() => ObservabilityCompareMetricSchema), optional: false },
  'dimension': { schema: lazySchema(() => ObservabilityCompareDimensionSchema), optional: false },
  'buckets': { schema: arraySchema(lazySchema(() => ObservabilityCompareBucketSchema)), optional: true },
}))

export const ObservabilityComputeResourceTypeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("lambda_function"), literalSchema("api_route"), literalSchema("ecs_task_definition"), literalSchema("sqs_queue")]))

export const ObservabilityCostAttributionSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'isEstimateAvailable': { schema: booleanSchema, optional: false },
  'estimatedUsd': { schema: numberSchema, optional: true },
  'periodEstimatedUsd': { schema: numberSchema, optional: true },
  'monthlyStorageRunRateUsd': { schema: numberSchema, optional: true },
  'pricedRunCoverage': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'isStorageEstimateAvailable': { schema: booleanSchema, optional: true },
  'currency': { schema: unionSchema([literalSchema("USD")]), optional: true },
  'components': { schema: arraySchema(lazySchema(() => ObservabilityCostComponentSchema)), optional: true },
  'pricedRuns': { schema: numberSchema, optional: true },
  'totalRuns': { schema: numberSchema, optional: true },
  'pricedOperations': { schema: numberSchema, optional: true },
  'totalOperations': { schema: numberSchema, optional: true },
  'methodology': { schema: stringSchema, optional: false },
  'rateCardVersion': { schema: stringSchema, optional: false },
  'assumptions': { schema: arraySchema(stringSchema), optional: true },
  'reconciliationStatus': { schema: unionSchema([literalSchema("not_configured"), literalSchema("unavailable"), literalSchema("available")]), optional: true },
  'reconciliationNote': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityCostComponentSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'key': { schema: stringSchema, optional: false },
  'label': { schema: stringSchema, optional: false },
  'estimatedUsd': { schema: numberSchema, optional: true },
  'coverage': { schema: stringSchema, optional: false },
  'basis': { schema: stringSchema, optional: false },
  'timeBasis': { schema: unionSchema([literalSchema("selected_period"), literalSchema("monthly_run_rate")]), optional: false },
  'estimateKind': { schema: unionSchema([literalSchema("measured_usage"), literalSchema("modeled_usage")]), optional: false },
  'isAvailable': { schema: booleanSchema, optional: true },
}))

export const ObservabilityCountBucketSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'key': { schema: stringSchema, optional: false },
  'count': { schema: numberSchema, optional: true },
}))

export const ObservabilityCriticalPathDiagnosticSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'analysisType': { schema: stringSchema, optional: false },
  'runs': { schema: numberSchema, optional: true },
  'recordedEndToEndMs': { schema: numberSchema, optional: true },
  'queueWaitShare': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'startupShare': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'imagePullShare': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'scientificStageShare': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'resultPersistenceShare': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'callbackShare': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'unclassifiedShare': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
}))

export const ObservabilityDriftDiagnosticSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'analysisType': { schema: stringSchema, optional: false },
  'currentTimedRuns': { schema: numberSchema, optional: true },
  'previousTimedRuns': { schema: numberSchema, optional: true },
  'currentP50Ms': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'previousP50Ms': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'relativeChange': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'direction': { schema: unionSchema([literalSchema("faster"), literalSchema("stable"), literalSchema("slower"), literalSchema("unmeasured")]), optional: false },
}))

export const ObservabilityDurationSummariesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'runDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'startupDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'queueWaitDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
}))

export const ObservabilityEcsTaskFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'taskArn': { schema: stringSchema, optional: false },
  'clusterArn': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'taskDefinitionArn': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'serviceName': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'runId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'createdAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'pullStartedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'pullStoppedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'startedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'stoppedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'startupDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'imagePullDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'activeDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'totalDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'usefulDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'stopCode': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'stoppedReason': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'exitCode': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'status': { schema: stringSchema, optional: false },
  'vCpu': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'memoryGb': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'imageDigest': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'cpuUtilizationPeakPercent': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'memoryUtilizationPeakPercent': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'ephemeralStorageUtilizationPeakPercent': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'networkRxPeakBytesPerSecond': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'networkTxPeakBytesPerSecond': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'storageReadBytes': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'storageWriteBytes': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'outOfMemory': { schema: booleanSchema, optional: true },
  'resourceMetricsCoverage': { schema: unionSchema([literalSchema("complete"), literalSchema("partial"), literalSchema("missing")]), optional: true },
}))

export const ObservabilityEfficiencyDiagnosticSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'analysisType': { schema: stringSchema, optional: false },
  'workloadSizeClass': { schema: unionSchema([lazySchema(() => ObservabilityWorkloadSizeClassSchema), stringSchema]), optional: false },
  'workerImageVersion': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'runs': { schema: numberSchema, optional: true },
  'durationPerInputGb': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'inputThroughput': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'costedRuns': { schema: numberSchema, optional: true },
  'estimatedCostPerInputGb': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: true },
  'estimatedCostPerInputFile': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: true },
}))

export const ObservabilityEnvironmentSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("dev"), literalSchema("beta"), literalSchema("prod")]))

export const ObservabilityEnvironmentHealthRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'topLimit': { schema: numberSchema, optional: true },
}))

export const ObservabilityEnvironmentHealthResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'generatedAt': { schema: stringSchema, optional: false },
  'components': { schema: arraySchema(lazySchema(() => ObservabilityCollectionComponentSchema)), optional: true },
  'retentionTables': { schema: arraySchema(lazySchema(() => ObservabilityRetentionTableStatusSchema)), optional: true },
  'totalRuns': { schema: numberSchema, optional: true },
  'failedRuns': { schema: numberSchema, optional: true },
  'openFailures': { schema: numberSchema, optional: true },
  'unconsumedFailures': { schema: numberSchema, optional: true },
  'clientErrors': { schema: numberSchema, optional: true },
  'rumSessions': { schema: numberSchema, optional: true },
  'startupDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'queueWaitDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'slowestSpans': { schema: arraySchema(lazySchema(() => ObservabilitySpanDurationSummarySchema)), optional: true },
  'failureCategories': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'runStatuses': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
}))

export const ObservabilityFailureCategorySchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("ApplicationException"), literalSchema("LambdaInvocationFailure"), literalSchema("LambdaTimeout"), literalSchema("EcsStartupFailure"), literalSchema("EcsUnexpectedStop"), literalSchema("OnDemandInstanceFailure"), literalSchema("WatchdogStop"), literalSchema("RuntimeDetectedDegradation"), literalSchema("ClientError")]))

export const ObservabilityFailureFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'id': { schema: stringSchema, optional: false },
  'environment': { schema: unionSchema([lazySchema(() => ObservabilityEnvironmentSchema), stringSchema]), optional: false },
  'groupKey': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'source': { schema: stringSchema, optional: false },
  'category': { schema: unionSchema([lazySchema(() => ObservabilityFailureCategorySchema), stringSchema]), optional: false },
  'severity': { schema: unionSchema([lazySchema(() => ObservabilitySeveritySchema), stringSchema]), optional: false },
  'status': { schema: unionSchema([lazySchema(() => ObservabilityFailureStatusSchema), stringSchema]), optional: false },
  'detectedAt': { schema: stringSchema, optional: false },
  'observedAt': { schema: stringSchema, optional: false },
  'runId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'analysisType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'projectId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'ownerUserId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'serviceName': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'runtimeType': { schema: unionSchema([lazySchema(() => ObservabilityRuntimeTypeSchema), stringSchema]), optional: false },
  'route': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'sessionId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'errorType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'message': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'fingerprint': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'logGroup': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'logStream': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'logDeepLink': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'attributes': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilityFailureGroupItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'id': { schema: stringSchema, optional: false },
  'environment': { schema: unionSchema([lazySchema(() => ObservabilityEnvironmentSchema), stringSchema]), optional: false },
  'groupKey': { schema: stringSchema, optional: false },
  'category': { schema: unionSchema([lazySchema(() => ObservabilityFailureCategorySchema), stringSchema]), optional: false },
  'severity': { schema: unionSchema([lazySchema(() => ObservabilitySeveritySchema), stringSchema]), optional: false },
  'errorType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'firstSeenAt': { schema: stringSchema, optional: false },
  'lastSeenAt': { schema: stringSchema, optional: false },
  'occurrenceCount': { schema: numberSchema, optional: true },
  'unconsumedCount': { schema: numberSchema, optional: true },
  'latestFailureId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'latestFailure': { schema: unionSchema([lazySchema(() => ObservabilityFailureQueueItemSchema), nullSchema]), optional: true },
}))

export const ObservabilityFailureGroupsRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'status': { schema: lazySchema(() => ObservabilityFailureQueueViewSchema), optional: true },
  'limit': { schema: numberSchema, optional: true },
  'offset': { schema: numberSchema, optional: true },
}))

export const ObservabilityFailureGroupsResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'groups': { schema: arraySchema(lazySchema(() => ObservabilityFailureGroupItemSchema)), optional: false },
  'total': { schema: numberSchema, optional: true },
  'offset': { schema: numberSchema, optional: true },
  'hasMore': { schema: booleanSchema, optional: false },
  'statusCounts': { schema: lazySchema(() => ObservabilityFailureStatusCountsSchema), optional: true },
}))

export const ObservabilityFailureOutcomeDiagnosticsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'reviewedFailures': { schema: numberSchema, optional: true },
  'resolvedFailures': { schema: numberSchema, optional: true },
  'ignoredFailures': { schema: numberSchema, optional: true },
  'timeToResolution': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'repeatedFailureGroups': { schema: numberSchema, optional: true },
}))

export const ObservabilityFailureQueueItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'failure': { schema: lazySchema(() => ObservabilityFailureFactSchema), optional: false },
  'queueStatus': { schema: unionSchema([lazySchema(() => ObservabilityFailureStatusSchema), stringSchema]), optional: false },
  'groupKey': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'ackedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'resolvedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'ignoredAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'consumedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'reviewedReason': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityFailureQueueRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'view': { schema: lazySchema(() => ObservabilityFailureQueueViewSchema), optional: true },
  'limit': { schema: numberSchema, optional: true },
  'offset': { schema: numberSchema, optional: true },
  'failureId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityFailureQueueResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'items': { schema: arraySchema(lazySchema(() => ObservabilityFailureQueueItemSchema)), optional: false },
  'total': { schema: numberSchema, optional: true },
  'offset': { schema: numberSchema, optional: true },
  'hasMore': { schema: booleanSchema, optional: false },
}))

export const ObservabilityFailureQueueViewSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("open"), literalSchema("acknowledged"), literalSchema("resolved"), literalSchema("ignored"), literalSchema("all")]))

export const ObservabilityFailureStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("open"), literalSchema("acknowledged"), literalSchema("resolved"), literalSchema("ignored")]))

export const ObservabilityFailureStatusCountsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'total': { schema: numberSchema, optional: true },
  'open': { schema: numberSchema, optional: true },
  'acknowledged': { schema: numberSchema, optional: true },
  'resolved': { schema: numberSchema, optional: true },
  'ignored': { schema: numberSchema, optional: true },
}))

export const ObservabilityFailureTransitionActionSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("acknowledge"), literalSchema("resolve"), literalSchema("ignore"), literalSchema("reopen")]))

export const ObservabilityFailureTransitionErrorSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'failureId': { schema: stringSchema, optional: false },
  'message': { schema: stringSchema, optional: false },
}))

export const ObservabilityFailureTransitionRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: lazySchema(() => ObservabilityEnvironmentSchema), optional: true },
  'failureId': { schema: stringSchema, optional: true },
  'action': { schema: lazySchema(() => ObservabilityFailureTransitionActionSchema), optional: false },
  'reason': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityFailureTransitionResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'item': { schema: lazySchema(() => ObservabilityFailureQueueItemSchema), optional: false },
}))

export const ObservabilityFailuresSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'totalFailures': { schema: numberSchema, optional: true },
  'openFailures': { schema: numberSchema, optional: true },
  'failureGroups': { schema: numberSchema, optional: true },
  'unconsumedFailures': { schema: numberSchema, optional: true },
  'byCategory': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'bySeverity': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'byStatus': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
}))

export const ObservabilityGovernedMetricDefinitionSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'key': { schema: lazySchema(() => ObservabilityCompareMetricSchema), optional: false },
  'displayName': { schema: stringSchema, optional: false },
  'description': { schema: stringSchema, optional: false },
  'family': { schema: stringSchema, optional: false },
  'source': { schema: stringSchema, optional: false },
  'unit': { schema: stringSchema, optional: false },
  'grain': { schema: stringSchema, optional: false },
  'formula': { schema: stringSchema, optional: false },
  'timeBasis': { schema: stringSchema, optional: false },
  'supportedDimensions': { schema: arraySchema(lazySchema(() => ObservabilityCompareDimensionSchema)), optional: true },
  'freshness': { schema: stringSchema, optional: false },
  'owner': { schema: stringSchema, optional: false },
  'coverage': { schema: stringSchema, optional: false },
  'caveats': { schema: arraySchema(stringSchema), optional: true },
}))

export const ObservabilityLambdaInvocationFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'serviceName': { schema: stringSchema, optional: false },
  'requestId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'functionVersion': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'observedAt': { schema: stringSchema, optional: false },
  'durationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'billedDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'memorySizeMb': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'maxMemoryUsedMb': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'initDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'restoreDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'status': { schema: stringSchema, optional: false },
  'errorType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'likelyColdStart': { schema: booleanSchema, optional: true },
  'logGroup': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'logStream': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityLogLineSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'timestamp': { schema: stringSchema, optional: false },
  'message': { schema: stringSchema, optional: false },
  'eventId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'ingestionTime': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityLogLookupRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: lazySchema(() => ObservabilityEnvironmentSchema), optional: false },
  'failureId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'runId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'logGroup': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'logStream': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'startTime': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'endTime': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'nextToken': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'maxEvents': { schema: numberSchema, optional: true },
  'maxBytes': { schema: numberSchema, optional: true },
}))

export const ObservabilityLogLookupResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'logGroup': { schema: stringSchema, optional: false },
  'logStream': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'startTime': { schema: stringSchema, optional: false },
  'endTime': { schema: stringSchema, optional: false },
  'events': { schema: arraySchema(lazySchema(() => ObservabilityLogLineSchema)), optional: false },
  'nextToken': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'truncatedByBytes': { schema: booleanSchema, optional: true },
}))

export const ObservabilityMetricDefinitionSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'name': { schema: stringSchema, optional: false },
  'family': { schema: stringSchema, optional: false },
  'source': { schema: stringSchema, optional: false },
  'unit': { schema: stringSchema, optional: false },
  'samples': { schema: numberSchema, optional: true },
  'lowConfidenceSamples': { schema: numberSchema, optional: true },
}))

export const ObservabilityMetricSampleFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'id': { schema: stringSchema, optional: false },
  'environment': { schema: unionSchema([lazySchema(() => ObservabilityEnvironmentSchema), stringSchema]), optional: false },
  'metricName': { schema: stringSchema, optional: false },
  'metricFamily': { schema: stringSchema, optional: false },
  'source': { schema: stringSchema, optional: false },
  'observedAt': { schema: stringSchema, optional: false },
  'dimensions': { schema: recordSchema(unknownSchema), optional: true },
  'unit': { schema: stringSchema, optional: false },
  'value': { schema: numberSchema, optional: false },
  'lowConfidence': { schema: booleanSchema, optional: true },
  'sourceVersion': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'attributes': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilityMetricSampleSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'metricName': { schema: stringSchema, optional: false },
  'metricFamily': { schema: stringSchema, optional: false },
  'unit': { schema: stringSchema, optional: false },
  'source': { schema: stringSchema, optional: false },
  'values': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'lowConfidenceSamples': { schema: numberSchema, optional: true },
}))

export const ObservabilityOperationalDiagnosticsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'outcomes': { schema: lazySchema(() => ObservabilityOutcomeDiagnosticsSchema), optional: false },
  'failureOutcomes': { schema: lazySchema(() => ObservabilityFailureOutcomeDiagnosticsSchema), optional: false },
  'bottlenecks': { schema: arraySchema(lazySchema(() => ObservabilityBottleneckDiagnosticSchema)), optional: false },
  'efficiency': { schema: arraySchema(lazySchema(() => ObservabilityEfficiencyDiagnosticSchema)), optional: false },
  'drift': { schema: arraySchema(lazySchema(() => ObservabilityDriftDiagnosticSchema)), optional: false },
  'criticalPath': { schema: arraySchema(lazySchema(() => ObservabilityCriticalPathDiagnosticSchema)), optional: true },
  'versionDrift': { schema: arraySchema(lazySchema(() => ObservabilityVersionDriftDiagnosticSchema)), optional: true },
}))

export const ObservabilityOutcomeDiagnosticsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'runs': { schema: numberSchema, optional: true },
  'completedRuns': { schema: numberSchema, optional: true },
  'failedRuns': { schema: numberSchema, optional: true },
  'cancelledRuns': { schema: numberSchema, optional: true },
  'completionRate': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'failureRate': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'timeToFirstProgress': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'rerunRuns': { schema: numberSchema, optional: true },
  'recoveredRuns': { schema: numberSchema, optional: true },
  'stalledRuns': { schema: numberSchema, optional: true },
  'timeToRecovery': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: true },
  'timeToFirstDurableResult': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: true },
  'resultViews': { schema: numberSchema, optional: true },
  'completedDownloads': { schema: numberSchema, optional: true },
}))

export const ObservabilityPercentilesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'count': { schema: numberSchema, optional: true },
  'average': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'minimum': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'p50': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'p95': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'p99': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'maximum': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'unit': { schema: stringSchema, optional: false },
}))

export const ObservabilityPerformancePeriodSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'periodStart': { schema: stringSchema, optional: false },
  'periodEnd': { schema: stringSchema, optional: false },
  'runs': { schema: numberSchema, optional: true },
  'timedRuns': { schema: numberSchema, optional: true },
  'duration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
}))

export const ObservabilityProductOutcomeNameSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("result_persisted"), literalSchema("result_viewed"), literalSchema("project_download_completed")]))

export const ObservabilityQueryFilterSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: lazySchema(() => ObservabilityEnvironmentSchema), optional: true },
  'window': { schema: lazySchema(() => ObservabilityQueryWindowSchema), optional: true },
  'analysisTypes': { schema: arraySchema(stringSchema), optional: true },
  'serviceNames': { schema: arraySchema(stringSchema), optional: true },
  'runtimeTypes': { schema: arraySchema(lazySchema(() => ObservabilityRuntimeTypeSchema)), optional: true },
  'sources': { schema: arraySchema(stringSchema), optional: true },
}))

export const ObservabilityQueryWindowSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'startTime': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'endTime': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityRawFactEnvelopeSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'kind': { schema: lazySchema(() => ObservabilityRawFactKindSchema), optional: false },
  'observedAt': { schema: stringSchema, optional: false },
  'fact': { schema: recordSchema(unknownSchema), optional: false },
}))

export const ObservabilityRawFactKindSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("run"), literalSchema("span"), literalSchema("failure"), literalSchema("metric"), literalSchema("rum_session"), literalSchema("rum_page_view"), literalSchema("rum_route_navigation"), literalSchema("rum_client_error"), literalSchema("rum_web_vital"), literalSchema("product_outcome")]))

export const ObservabilityRetentionTableStatusSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'tableName': { schema: stringSchema, optional: false },
  'snapshotDate': { schema: stringSchema, optional: false },
  'measuredAt': { schema: stringSchema, optional: false },
  'retentionDays': { schema: numberSchema, optional: true },
  'enabled': { schema: booleanSchema, optional: false },
  'eligibleRowsBeforeBatch': { schema: numberSchema, optional: true },
  'remainingEligibleRows': { schema: numberSchema, optional: true },
  'deletedRows': { schema: numberSchema, optional: true },
  'eligibleSourceDays': { schema: numberSchema, optional: true },
  'coveredSourceDays': { schema: numberSchema, optional: true },
  'missingRollupDays': { schema: numberSchema, optional: true },
  'rollupCoverageComplete': { schema: booleanSchema, optional: false },
  'cleanupBlockedReason': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'oldestEligibleAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'newestEligibleAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'heapBytes': { schema: numberSchema, optional: true },
  'indexBytes': { schema: numberSchema, optional: true },
  'totalBytes': { schema: numberSchema, optional: true },
}))

export const ObservabilityRumClientErrorFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'id': { schema: stringSchema, optional: false },
  'environment': { schema: unionSchema([lazySchema(() => ObservabilityEnvironmentSchema), stringSchema]), optional: false },
  'sessionId': { schema: stringSchema, optional: false },
  'route': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'errorType': { schema: stringSchema, optional: false },
  'message': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'observedAt': { schema: stringSchema, optional: false },
  'failureId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'attributes': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilityRumEventTypeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("session_started"), literalSchema("session_updated"), literalSchema("session_ended"), literalSchema("page_view"), literalSchema("route_navigation"), literalSchema("client_error"), literalSchema("web_vital"), literalSchema("product_outcome")]))

export const ObservabilityRumPageViewFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'id': { schema: stringSchema, optional: false },
  'environment': { schema: unionSchema([lazySchema(() => ObservabilityEnvironmentSchema), stringSchema]), optional: false },
  'sessionId': { schema: stringSchema, optional: false },
  'route': { schema: stringSchema, optional: false },
  'referrer': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'observedAt': { schema: stringSchema, optional: false },
  'loadDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'attributes': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilityRumRouteNavigationFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'id': { schema: stringSchema, optional: false },
  'environment': { schema: unionSchema([lazySchema(() => ObservabilityEnvironmentSchema), stringSchema]), optional: false },
  'sessionId': { schema: stringSchema, optional: false },
  'fromRoute': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'toRoute': { schema: stringSchema, optional: false },
  'observedAt': { schema: stringSchema, optional: false },
  'durationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'attributes': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilityRumRouteSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'route': { schema: stringSchema, optional: false },
  'pageViews': { schema: numberSchema, optional: true },
  'loadDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
}))

export const ObservabilityRumSessionDetailRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'sessionId': { schema: stringSchema, optional: true },
  'rawFactLimit': { schema: numberSchema, optional: true },
}))

export const ObservabilityRumSessionDetailResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'session': { schema: unionSchema([lazySchema(() => ObservabilityRumSessionFactSchema), nullSchema]), optional: true },
  'pageViews': { schema: arraySchema(lazySchema(() => ObservabilityRumPageViewFactSchema)), optional: true },
  'routeNavigations': { schema: arraySchema(lazySchema(() => ObservabilityRumRouteNavigationFactSchema)), optional: true },
  'clientErrors': { schema: arraySchema(lazySchema(() => ObservabilityRumClientErrorFactSchema)), optional: true },
  'webVitals': { schema: arraySchema(lazySchema(() => ObservabilityRumWebVitalFactSchema)), optional: true },
  'failures': { schema: arraySchema(lazySchema(() => ObservabilityFailureFactSchema)), optional: true },
  'relatedFacts': { schema: arraySchema(lazySchema(() => ObservabilityRawFactEnvelopeSchema)), optional: true },
}))

export const ObservabilityRumSessionFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: unionSchema([lazySchema(() => ObservabilityEnvironmentSchema), stringSchema]), optional: false },
  'sessionId': { schema: stringSchema, optional: false },
  'userId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'browser': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'browserVersion': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'device': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'os': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'startedAt': { schema: stringSchema, optional: false },
  'endedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'lastSeenAt': { schema: stringSchema, optional: false },
  'attributes': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilityRumSessionSearchItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'session': { schema: lazySchema(() => ObservabilityRumSessionFactSchema), optional: false },
  'pageViews': { schema: numberSchema, optional: true },
  'clientErrors': { schema: numberSchema, optional: true },
  'webVitals': { schema: numberSchema, optional: true },
  'lastRoute': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityRumSessionSearchRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'search': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'routes': { schema: arraySchema(stringSchema), optional: true },
  'browsers': { schema: arraySchema(stringSchema), optional: true },
  'devices': { schema: arraySchema(stringSchema), optional: true },
  'vitalNames': { schema: arraySchema(lazySchema(() => RumWebVitalNameSchema)), optional: true },
  'hasClientErrors': { schema: unionSchema([booleanSchema, nullSchema]), optional: true },
  'limit': { schema: numberSchema, optional: true },
  'offset': { schema: numberSchema, optional: true },
}))

export const ObservabilityRumSessionSearchResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'generatedAt': { schema: stringSchema, optional: false },
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'items': { schema: arraySchema(lazySchema(() => ObservabilityRumSessionSearchItemSchema)), optional: true },
  'offset': { schema: numberSchema, optional: true },
  'hasMore': { schema: booleanSchema, optional: true },
}))

export const ObservabilityRumSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sessions': { schema: numberSchema, optional: true },
  'samplingRate': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'samplingConfigurationMixed': { schema: booleanSchema, optional: true },
  'pageViews': { schema: numberSchema, optional: true },
  'routeNavigations': { schema: numberSchema, optional: true },
  'clientErrors': { schema: numberSchema, optional: true },
  'webVitals': { schema: numberSchema, optional: true },
  'pageLoadDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'routeNavigationDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'topRoutes': { schema: arraySchema(lazySchema(() => ObservabilityRumRouteSummarySchema)), optional: true },
  'webVitalSummaries': { schema: arraySchema(lazySchema(() => ObservabilityRumWebVitalSummarySchema)), optional: true },
}))

export const ObservabilityRumWebVitalFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'id': { schema: stringSchema, optional: false },
  'environment': { schema: unionSchema([lazySchema(() => ObservabilityEnvironmentSchema), stringSchema]), optional: false },
  'sessionId': { schema: stringSchema, optional: false },
  'route': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'metricName': { schema: unionSchema([lazySchema(() => RumWebVitalNameSchema), stringSchema]), optional: false },
  'value': { schema: numberSchema, optional: false },
  'observedAt': { schema: stringSchema, optional: false },
  'attributes': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilityRumWebVitalSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'metricName': { schema: unionSchema([lazySchema(() => RumWebVitalNameSchema), stringSchema]), optional: false },
  'route': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'values': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'p75': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
}))

export const ObservabilityRunDetailRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'runId': { schema: stringSchema, optional: true },
  'rawFactLimit': { schema: numberSchema, optional: true },
}))

export const ObservabilityRunDetailResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'run': { schema: unionSchema([lazySchema(() => ObservabilityRunFactSchema), nullSchema]), optional: true },
  'spans': { schema: arraySchema(lazySchema(() => ObservabilitySpanFactSchema)), optional: true },
  'failures': { schema: arraySchema(lazySchema(() => ObservabilityFailureFactSchema)), optional: true },
  'metricSamples': { schema: arraySchema(lazySchema(() => ObservabilityMetricSampleFactSchema)), optional: true },
  'relatedFacts': { schema: arraySchema(lazySchema(() => ObservabilityRawFactEnvelopeSchema)), optional: true },
}))

export const ObservabilityRunFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: unionSchema([lazySchema(() => ObservabilityEnvironmentSchema), stringSchema]), optional: false },
  'runId': { schema: stringSchema, optional: false },
  'source': { schema: stringSchema, optional: false },
  'analysisType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'jobKind': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'projectId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'ownerUserId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'serviceName': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'runtimeType': { schema: unionSchema([lazySchema(() => ObservabilityRuntimeTypeSchema), stringSchema]), optional: false },
  'workerImageVersion': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'workloadSizeClass': { schema: unionSchema([lazySchema(() => ObservabilityWorkloadSizeClassSchema), stringSchema]), optional: true },
  'status': { schema: unionSchema([unionSchema([lazySchema(() => ObservabilityRunStatusSchema), stringSchema]), nullSchema]), optional: true },
  'queuedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'startedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'firstProgressAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'terminalAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'observedAt': { schema: stringSchema, optional: false },
  'endToEndDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'queueWaitDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'startupDurationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'inputFileCount': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'inputTotalBytes': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'workloadHints': { schema: recordSchema(unknownSchema), optional: true },
  'attributes': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilityRunSearchRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'search': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'statuses': { schema: arraySchema(lazySchema(() => ObservabilityRunStatusSchema)), optional: true },
  'workloadSizeClasses': { schema: arraySchema(lazySchema(() => ObservabilityWorkloadSizeClassSchema)), optional: true },
  'workerImageVersions': { schema: arraySchema(stringSchema), optional: true },
  'limit': { schema: numberSchema, optional: true },
  'offset': { schema: numberSchema, optional: true },
}))

export const ObservabilityRunSearchResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'generatedAt': { schema: stringSchema, optional: false },
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'items': { schema: arraySchema(lazySchema(() => ObservabilityRunFactSchema)), optional: true },
  'offset': { schema: numberSchema, optional: true },
  'hasMore': { schema: booleanSchema, optional: true },
}))

export const ObservabilityRunStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("queued"), literalSchema("starting"), literalSchema("running"), literalSchema("completed"), literalSchema("failed"), literalSchema("cancelled"), literalSchema("unknown")]))

export const ObservabilityRunsSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'totalRuns': { schema: numberSchema, optional: true },
  'terminalRuns': { schema: numberSchema, optional: true },
  'failedRuns': { schema: numberSchema, optional: true },
  'durations': { schema: lazySchema(() => ObservabilityDurationSummariesSchema), optional: false },
  'byStatus': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'byAnalysisType': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'byRuntimeType': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
}))

export const ObservabilityRuntimeTypeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("lambda"), literalSchema("ecs"), literalSchema("browser"), literalSchema("unknown")]))

export const ObservabilityServiceConfigurationSnapshotSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'observedAt': { schema: stringSchema, optional: false },
  'deploymentId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'version': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'configurationHash': { schema: stringSchema, optional: false },
  'configuration': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilityServiceDetailRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'resourceType': { schema: lazySchema(() => ObservabilityComputeResourceTypeSchema), optional: false },
  'resourceKey': { schema: stringSchema, optional: true },
  'factLimit': { schema: numberSchema, optional: true },
}))

export const ObservabilityServiceDetailResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'generatedAt': { schema: stringSchema, optional: false },
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'item': { schema: unionSchema([lazySchema(() => ObservabilityServiceInventoryItemSchema), nullSchema]), optional: true },
  'previousWindow': { schema: unionSchema([lazySchema(() => ObservabilityServiceMetricSummarySchema), nullSchema]), optional: true },
  'history': { schema: arraySchema(lazySchema(() => ObservabilityServiceHistoryPointSchema)), optional: true },
  'versions': { schema: arraySchema(lazySchema(() => ObservabilityServiceVersionSummarySchema)), optional: true },
  'metricProvenance': { schema: arraySchema(lazySchema(() => ObservabilityServiceMetricProvenanceSchema)), optional: true },
  'configurationHistory': { schema: arraySchema(lazySchema(() => ObservabilityServiceConfigurationSnapshotSchema)), optional: true },
  'workloadBreakdown': { schema: arraySchema(lazySchema(() => ObservabilityServiceWorkloadSummarySchema)), optional: true },
  'lambdaInvocations': { schema: arraySchema(lazySchema(() => ObservabilityLambdaInvocationFactSchema)), optional: true },
  'apiRequests': { schema: arraySchema(lazySchema(() => ObservabilityApiRequestFactSchema)), optional: true },
  'ecsTasks': { schema: arraySchema(lazySchema(() => ObservabilityEcsTaskFactSchema)), optional: true },
  'insights': { schema: arraySchema(stringSchema), optional: true },
}))

export const ObservabilityServiceHistoryPointSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'periodStart': { schema: stringSchema, optional: false },
  'periodEnd': { schema: stringSchema, optional: false },
  'metrics': { schema: lazySchema(() => ObservabilityServiceMetricSummarySchema), optional: false },
}))

export const ObservabilityServiceInventoryItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'resourceType': { schema: lazySchema(() => ObservabilityComputeResourceTypeSchema), optional: false },
  'resourceKey': { schema: stringSchema, optional: false },
  'displayName': { schema: stringSchema, optional: false },
  'serviceName': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'runtimeType': { schema: unionSchema([lazySchema(() => ObservabilityRuntimeTypeSchema), stringSchema]), optional: false },
  'version': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'lastObservedAt': { schema: stringSchema, optional: false },
  'telemetryCoverage': { schema: lazySchema(() => ObservabilityTelemetryCoverageSchema), optional: false },
  'coverageSummary': { schema: stringSchema, optional: false },
  'metrics': { schema: lazySchema(() => ObservabilityServiceMetricSummarySchema), optional: false },
  'nativeMetrics': { schema: recordSchema(numberSchema), optional: true },
  'configuration': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilityServiceInventoryRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'resourceTypes': { schema: arraySchema(lazySchema(() => ObservabilityComputeResourceTypeSchema)), optional: true },
  'search': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'limit': { schema: numberSchema, optional: true },
  'offset': { schema: numberSchema, optional: true },
}))

export const ObservabilityServiceInventoryResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'generatedAt': { schema: stringSchema, optional: false },
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'items': { schema: arraySchema(lazySchema(() => ObservabilityServiceInventoryItemSchema)), optional: true },
  'total': { schema: numberSchema, optional: true },
  'offset': { schema: numberSchema, optional: true },
  'hasMore': { schema: booleanSchema, optional: true },
  'byResourceType': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
}))

export const ObservabilityServiceMetricProvenanceSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'metricKey': { schema: stringSchema, optional: false },
  'label': { schema: stringSchema, optional: false },
  'source': { schema: stringSchema, optional: false },
  'sourceType': { schema: unionSchema([literalSchema("operation_facts"), literalSchema("aws_native"), literalSchema("inventory"), literalSchema("derived")]), optional: false },
  'status': { schema: unionSchema([literalSchema("available"), literalSchema("partial"), literalSchema("missing"), literalSchema("not_applicable")]), optional: false },
  'windowStart': { schema: stringSchema, optional: false },
  'windowEnd': { schema: stringSchema, optional: false },
  'sampleCount': { schema: numberSchema, optional: true },
  'firstObservedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'lastObservedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'freshnessSeconds': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'detail': { schema: stringSchema, optional: false },
}))

export const ObservabilityServiceMetricSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'observations': { schema: numberSchema, optional: true },
  'successful': { schema: numberSchema, optional: true },
  'errors': { schema: numberSchema, optional: true },
  'errorRate': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'clientErrors': { schema: numberSchema, optional: true },
  'serverErrors': { schema: numberSchema, optional: true },
  'throttles': { schema: numberSchema, optional: true },
  'coldStarts': { schema: numberSchema, optional: true },
  'coldStartRate': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'duration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'billedDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'integrationDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'initializationDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'restoreDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'runtimeExtensionDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'startupDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'activeDuration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'maxConcurrency': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'allocatedMemoryMb': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'memoryUsedMb': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'memoryUtilization': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'cpuUtilization': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'cpuTotalTime': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'networkTotalBytes': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'temporaryStorageUsedBytes': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'fileDescriptorsUsed': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'threadsUsed': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'usefulComputeShare': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'durationPerInputGbMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'memoryHeadroomAtP95Mb': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'timeoutHeadroomAtP95Ms': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'latestAverageCpuHeadroomPercent': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'estimatedCostUsd': { schema: numberSchema, optional: true },
}))

export const ObservabilityServiceVersionSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'version': { schema: stringSchema, optional: false },
  'deploymentId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'memorySizeMb': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'observations': { schema: numberSchema, optional: true },
  'errors': { schema: numberSchema, optional: true },
  'duration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'estimatedCostUsd': { schema: numberSchema, optional: true },
}))

export const ObservabilityServiceWorkloadSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'workloadSizeClass': { schema: unionSchema([lazySchema(() => ObservabilityWorkloadSizeClassSchema), stringSchema]), optional: false },
  'observations': { schema: numberSchema, optional: true },
  'inputFileCount': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'inputTotalBytes': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'duration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
}))

export const ObservabilitySeveritySchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("info"), literalSchema("warning"), literalSchema("error"), literalSchema("critical")]))

export const ObservabilitySignalEvidenceSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'signal': { schema: lazySchema(() => ObservabilitySignalFamilySchema), optional: false },
  'observations': { schema: numberSchema, optional: true },
  'lastObservedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'lastReceivedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilitySignalFamilySchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("runs"), literalSchema("failures"), literalSchema("spans"), literalSchema("metrics"), literalSchema("browser_sessions")]))

export const ObservabilitySpanDurationSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'spanName': { schema: stringSchema, optional: false },
  'spanKind': { schema: stringSchema, optional: false },
  'analysisType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'runtimeType': { schema: unionSchema([lazySchema(() => ObservabilityRuntimeTypeSchema), stringSchema]), optional: false },
  'durations': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'failedSpans': { schema: numberSchema, optional: true },
}))

export const ObservabilitySpanFactSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'id': { schema: stringSchema, optional: false },
  'environment': { schema: unionSchema([lazySchema(() => ObservabilityEnvironmentSchema), stringSchema]), optional: false },
  'runId': { schema: stringSchema, optional: false },
  'parentSpanId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'spanName': { schema: stringSchema, optional: false },
  'spanKind': { schema: stringSchema, optional: false },
  'source': { schema: stringSchema, optional: false },
  'analysisType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'serviceName': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'runtimeType': { schema: unionSchema([lazySchema(() => ObservabilityRuntimeTypeSchema), stringSchema]), optional: false },
  'startedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'endedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'observedAt': { schema: stringSchema, optional: false },
  'durationMs': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'status': { schema: unionSchema([lazySchema(() => ObservabilitySpanStatusSchema), stringSchema]), optional: false },
  'attributes': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ObservabilitySpanStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("completed"), literalSchema("failed")]))

export const ObservabilityStorageCategorySchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("uploaded_data"), literalSchema("analysis_result"), literalSchema("saved_input")]))

export const ObservabilityStorageCategorySummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'category': { schema: lazySchema(() => ObservabilityStorageCategorySchema), optional: false },
  'objects': { schema: numberSchema, optional: true },
  'bytes': { schema: numberSchema, optional: true },
  'inventoryStatus': { schema: lazySchema(() => ObservabilityCollectionStatusSchema), optional: true },
  'lastReconciledAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityStorageSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'objects': { schema: numberSchema, optional: true },
  'bytes': { schema: numberSchema, optional: true },
  'byCategory': { schema: arraySchema(lazySchema(() => ObservabilityStorageCategorySummarySchema)), optional: true },
  'createdBytesInWindow': { schema: numberSchema, optional: true },
  'deletedBytesInWindow': { schema: numberSchema, optional: true },
  'netBytesInWindow': { schema: numberSchema, optional: false },
  'lastChangedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'coverageStartedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'reconciledObjects': { schema: numberSchema, optional: true },
  'hasReconciledInventory': { schema: booleanSchema, optional: true },
  'reconciledCategories': { schema: numberSchema, optional: true },
  'inventoryStatus': { schema: lazySchema(() => ObservabilityCollectionStatusSchema), optional: true },
  'lastReconciledAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilitySummaryRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'topLimit': { schema: numberSchema, optional: true },
}))

export const ObservabilitySummaryResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'generatedAt': { schema: stringSchema, optional: false },
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'runs': { schema: lazySchema(() => ObservabilityRunsSummarySchema), optional: false },
  'failures': { schema: lazySchema(() => ObservabilityFailuresSummarySchema), optional: false },
  'spans': { schema: arraySchema(lazySchema(() => ObservabilitySpanDurationSummarySchema)), optional: false },
  'metricSamples': { schema: arraySchema(lazySchema(() => ObservabilityMetricSampleSummarySchema)), optional: false },
  'rum': { schema: lazySchema(() => ObservabilityRumSummarySchema), optional: false },
  'usage': { schema: lazySchema(() => ObservabilityUsageSummarySchema), optional: false },
  'signalEvidence': { schema: arraySchema(lazySchema(() => ObservabilitySignalEvidenceSchema)), optional: true },
  'diagnostics': { schema: unionSchema([lazySchema(() => ObservabilityOperationalDiagnosticsSchema), nullSchema]), optional: true },
}))

export const ObservabilityTelemetryCoverageSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("complete"), literalSchema("partial"), literalSchema("missing")]))

export const ObservabilityUsageInventoryRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'limit': { schema: numberSchema, optional: true },
}))

export const ObservabilityUsageInventoryResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'users': { schema: arraySchema(lazySchema(() => ObservabilityUsageUserItemSchema)), optional: true },
  'projects': { schema: arraySchema(lazySchema(() => ObservabilityUsageProjectItemSchema)), optional: true },
  'filesByAnalysisType': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'storageByCategory': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
  'storage': { schema: lazySchema(() => ObservabilityStorageSummarySchema), optional: false },
  'workflowCoverage': { schema: arraySchema(lazySchema(() => ObservabilityWorkflowCoverageItemSchema)), optional: true },
  'cost': { schema: lazySchema(() => ObservabilityCostAttributionSchema), optional: false },
}))

export const ObservabilityUsageProjectItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'projectName': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'ownerUserId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'createdAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'membershipRole': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'runs': { schema: numberSchema, optional: true },
  'workflows': { schema: numberSchema, optional: true },
  'inputFiles': { schema: numberSchema, optional: true },
  'inputBytes': { schema: numberSchema, optional: true },
  'relatedFailures': { schema: numberSchema, optional: true },
  'latestRunAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityUsageSubjectRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'filter': { schema: lazySchema(() => ObservabilityQueryFilterSchema), optional: true },
  'subjectType': { schema: lazySchema(() => ObservabilityUsageSubjectTypeSchema), optional: false },
  'subjectId': { schema: stringSchema, optional: true },
  'recentRunLimit': { schema: numberSchema, optional: true },
}))

export const ObservabilityUsageSubjectResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'generatedAt': { schema: stringSchema, optional: false },
  'filter': { schema: lazySchema(() => ObservabilityAppliedQueryFilterSchema), optional: false },
  'subjectType': { schema: lazySchema(() => ObservabilityUsageSubjectTypeSchema), optional: false },
  'subjectId': { schema: stringSchema, optional: false },
  'ownerUserId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'projects': { schema: arraySchema(lazySchema(() => ObservabilityUsageProjectItemSchema)), optional: true },
  'workflows': { schema: arraySchema(lazySchema(() => ObservabilityWorkflowCoverageItemSchema)), optional: true },
  'recentRuns': { schema: arraySchema(lazySchema(() => ObservabilityRunFactSchema)), optional: true },
  'performanceHistory': { schema: arraySchema(lazySchema(() => ObservabilityPerformancePeriodSchema)), optional: true },
  'storage': { schema: lazySchema(() => ObservabilityStorageSummarySchema), optional: false },
  'cost': { schema: lazySchema(() => ObservabilityCostAttributionSchema), optional: false },
}))

export const ObservabilityUsageSubjectTypeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("user"), literalSchema("project")]))

export const ObservabilityUsageSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'uniqueUsers': { schema: numberSchema, optional: true },
  'uniqueProjects': { schema: numberSchema, optional: true },
  'inputFiles': { schema: numberSchema, optional: true },
  'inputBytes': { schema: numberSchema, optional: true },
  'runsByJobKind': { schema: arraySchema(lazySchema(() => ObservabilityCountBucketSchema)), optional: true },
}))

export const ObservabilityUsageUserItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'ownerUserId': { schema: stringSchema, optional: false },
  'runs': { schema: numberSchema, optional: true },
  'projects': { schema: numberSchema, optional: true },
  'workflows': { schema: numberSchema, optional: true },
  'inputFiles': { schema: numberSchema, optional: true },
  'inputBytes': { schema: numberSchema, optional: true },
  'relatedFailures': { schema: numberSchema, optional: true },
  'latestRunAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityUserAccessItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'username': { schema: stringSchema, optional: false },
  'email': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'sub': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'enabled': { schema: booleanSchema, optional: false },
  'userStatus': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'saasAccess': { schema: booleanSchema, optional: false },
  'createdAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'updatedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityUserAccessListRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: lazySchema(() => ObservabilityEnvironmentSchema), optional: true },
  'limit': { schema: numberSchema, optional: true },
  'paginationToken': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityUserAccessListResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: lazySchema(() => ObservabilityEnvironmentSchema), optional: false },
  'users': { schema: arraySchema(lazySchema(() => ObservabilityUserAccessItemSchema)), optional: true },
  'paginationToken': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityUserAccessUpdateRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: lazySchema(() => ObservabilityEnvironmentSchema), optional: true },
  'username': { schema: stringSchema, optional: true },
  'saasAccess': { schema: booleanSchema, optional: false },
}))

export const ObservabilityUserAccessUpdateResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'environment': { schema: lazySchema(() => ObservabilityEnvironmentSchema), optional: false },
  'user': { schema: lazySchema(() => ObservabilityUserAccessItemSchema), optional: false },
}))

export const ObservabilityVersionDriftDiagnosticSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'analysisType': { schema: stringSchema, optional: false },
  'currentVersion': { schema: stringSchema, optional: false },
  'baselineVersion': { schema: stringSchema, optional: false },
  'currentRuns': { schema: numberSchema, optional: true },
  'baselineRuns': { schema: numberSchema, optional: true },
  'currentP50Ms': { schema: numberSchema, optional: true },
  'baselineP50Ms': { schema: numberSchema, optional: true },
  'relativeChange': { schema: numberSchema, optional: false },
  'direction': { schema: unionSchema([literalSchema("faster"), literalSchema("stable"), literalSchema("slower")]), optional: false },
}))

export const ObservabilityWorkflowCoverageItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'analysisType': { schema: stringSchema, optional: false },
  'runs': { schema: numberSchema, optional: true },
  'completedRuns': { schema: numberSchema, optional: true },
  'failedRuns': { schema: numberSchema, optional: true },
  'users': { schema: numberSchema, optional: true },
  'projects': { schema: numberSchema, optional: true },
  'timedRuns': { schema: numberSchema, optional: true },
  'duration': { schema: lazySchema(() => ObservabilityPercentilesSchema), optional: false },
  'lastRunAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ObservabilityWorkloadSizeClassSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("small"), literalSchema("medium"), literalSchema("large"), literalSchema("unknown")]))

export const OnDemandAddTaskDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'success': { schema: booleanSchema, optional: false },
  'runId': { schema: stringSchema, optional: false },
}))

export const OnDemandAddTaskRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
  'analysisFunctionSubType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'analysis': { schema: lazySchema(() => AnalysisRequestTypeSchema), optional: false },
  'passthroughFields': { schema: recordSchema(unknownSchema), optional: true },
}))

export const OnDemandAddTaskResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => OnDemandAddTaskDataSchema), optional: false },
}))

export const OnDemandInstanceStatusEventSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'projectName': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
  'ecsStatus': { schema: lazySchema(() => EcsStatusSchema), optional: false },
  'running': { schema: booleanSchema, optional: false },
  'progress': { schema: numberSchema, optional: false },
  'progressMessage': { schema: stringSchema, optional: false },
  'errorMessage': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'runId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'ownerUserId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'startedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'lastUpdated': { schema: stringSchema, optional: false },
  'eventVersion': { schema: numberSchema, optional: false },
}))

export const OnDemandRestartDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'success': { schema: booleanSchema, optional: false },
}))

export const OnDemandRestartRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
}))

export const OnDemandRestartResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => OnDemandRestartDataSchema), optional: false },
}))

export const OnDemandRuntimeSnapshotRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({

}))

export const OnDemandRuntimeSnapshotResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RuntimeSnapshotEventSchema), optional: false },
}))

export const OnDemandStartRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'analysisType': { schema: stringSchema, optional: false },
}))

export const OnDemandStartResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => StatusSchema), optional: false },
}))

export const ParametersGroupingSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'peakFittingParameters': { schema: lazySchema(() => S3FileCheckSchema), optional: false },
  'whParameters': { schema: lazySchema(() => S3FileCheckSchema), optional: false },
  'mwhParameters': { schema: lazySchema(() => S3FileCheckSchema), optional: false },
  'subgrainSizeEstimateParameters': { schema: lazySchema(() => S3FileCheckSchema), optional: false },
  'densityParameters': { schema: lazySchema(() => S3FileCheckSchema), optional: false },
}))

export const PartitionSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'range': { schema: lazySchema(() => RangeModelSchema), optional: false },
  'peaks': { schema: arraySchema(lazySchema(() => PartitionPeakSchema)), optional: false },
  'baseline': { schema: lazySchema(() => BaselineModelSchema), optional: false },
  'fitConfig': { schema: unionSchema([lazySchema(() => PartitionFitConfigSchema), nullSchema]), optional: true },
}))

export const PartitionConstraintNumberSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sigmaMin': { schema: numberSchema, optional: false },
  'sigmaMax': { schema: numberSchema, optional: false },
  'amplitudeMin': { schema: numberSchema, optional: false },
  'amplitudeMax': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'fractionMin': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'fractionMax': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'xMin': { schema: numberSchema, optional: false },
  'xMax': { schema: numberSchema, optional: false },
}))

export const PartitionFitConfigSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'maxNfev': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'timeLimit': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'verbose': { schema: unionSchema([booleanSchema, nullSchema]), optional: true },
}))

export const PartitionFittingSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: arraySchema(numberSchema), optional: false },
  'originalData': { schema: lazySchema(() => CurveSchema), optional: false },
  'bestFit': { schema: lazySchema(() => CurveSchema), optional: false },
  'background': { schema: lazySchema(() => CurveSchema), optional: false },
  'components': { schema: lazySchema(() => ComponentsCurvesSchema), optional: false },
}))

export const PartitionPeakSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: numberSchema, optional: false },
  'y': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'function': { schema: unionSchema([literalSchema("pv"), literalSchema("g"), literalSchema("l"), literalSchema("p")]), optional: false },
  'includeInAnalysis': { schema: booleanSchema, optional: false },
  'weightXMin': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'weightXMax': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'constraint': { schema: lazySchema(() => PartitionConstraintNumberSchema), optional: false },
}))

export const PeakFittingFittingDataFileSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => PeakFittingResultModelSchema)))

export const PeakFittingFittingModelSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => PeakFittingFittingDataFileSchema)))

export const PeakFittingInputsModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'movingPeaks': { schema: booleanSchema, optional: true },
  'peakMargin': { schema: numberSchema, optional: true },
  'partitions': { schema: arraySchema(lazySchema(() => PartitionSchema)), optional: false },
}))

export const PeakFittingPartitionFittingDataFileSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => PartitionFittingSchema)))

export const PeakFittingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'userId': { schema: stringSchema, optional: false },
  'files': { schema: unionSchema([lazySchema(() => FilesAnalysisModelSchema), lazySchema(() => FilesAnalysisModelSingleSchema)]), optional: false },
  'inputs': { schema: lazySchema(() => PeakFittingInputsModelSchema), optional: false },
  'maskCreator': { schema: unionSchema([lazySchema(() => MaskCreatorStateSchema), nullSchema]), optional: true },
}))

export const PeakFittingResultModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'amplitude': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'breadth': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'center': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'fwhm': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'fwhm_cauchy': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'fwhm_gaussian': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'fraction': { schema: unionSchema([lazySchema(() => ValueUncertaintySchema), nullSchema]), optional: false },
  'height': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'sigma': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
}))

export const PeakFittingServerlessCallbackFittingCallbackFittingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
}))

export const PeakFittingServerlessCallbackParametersCallbackParametersRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataFiles': { schema: arraySchema(stringSchema), optional: false },
}))

export const PeakFittingServerlessCallbackParametersCallbackParametersResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => PeakFittingFittingModelSchema), optional: false },
}))

export const PeakFittingWavelengthSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'value': { schema: numberSchema, optional: false },
  'fileValue': { schema: numberSchema, optional: false },
}))

export const PermanentDeleteProjectRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const PermanentDeleteProjectResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: stringSchema, optional: false },
}))

export const PhaseCifSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => PhasesSchema)))

export const PhaseEntrySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'tth': { schema: numberSchema, optional: false },
  'double': { schema: numberSchema, optional: false },
  'hkl': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const PhaseQuantificationInputsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'peakFitting': { schema: lazySchema(() => PeakFittingInputsModelSchema), optional: false },
  'bFactor': { schema: recordSchema(numberSchema), optional: false },
  'bFactorMode': { schema: lazySchema(() => DebyeWallerModeSchema), optional: true },
  'bFactorFile': { schema: unionSchema([lazySchema(() => FilesFilterFileModelSchema), nullSchema]), optional: true },
}))

export const PhaseQuantificationRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'userId': { schema: stringSchema, optional: false },
  'files': { schema: lazySchema(() => FilesAnalysisModelSchema), optional: false },
  'inputs': { schema: lazySchema(() => PhaseQuantificationInputsSchema), optional: false },
  'maskCreator': { schema: unionSchema([lazySchema(() => MaskCreatorStateSchema), nullSchema]), optional: true },
}))

export const PhaseQuantificationServerlessCallbackFittingCallbackFittingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
}))

export const PhaseQuantificationServerlessCallbackParametersCallbackParametersRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataFiles': { schema: arraySchema(stringSchema), optional: false },
}))

export const PhaseQuantificationServerlessCallbackParametersCallbackParametersResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => CallbackParametersCallbackParametersDataSchema), optional: false },
}))

export const PhaseQuantificationServerlessCallbackReportCallbackReportRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'columnKey': { schema: stringSchema, optional: false },
}))

export const PhaseQuantificationServerlessCallbackReportCallbackReportResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => PhaseQuantificationServerlessCallbackReportReportColumnPayloadSchema), optional: false },
}))

export const PhaseQuantificationServerlessCallbackReportMetaCallbackReportMetaRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const PhaseQuantificationServerlessCallbackReportMetaCallbackReportMetaResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => PhaseQuantificationServerlessCallbackReportMetaReportMetaPayloadSchema), optional: false },
}))

export const PhaseQuantificationServerlessCallbackReportMetaReportMetaPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'rowKeys': { schema: arraySchema(stringSchema), optional: false },
  'columnSchema': { schema: arraySchema(stringSchema), optional: false },
  'mask': { schema: unionSchema([arraySchema(booleanSchema), nullSchema]), optional: true },
  'rsquaredByPartition': { schema: unionSchema([recordSchema(arraySchema(unionSchema([numberSchema, nullSchema]))), nullSchema]), optional: true },
  'columnPartitions': { schema: unionSchema([recordSchema(numberSchema), nullSchema]), optional: true },
}))

export const PhaseQuantificationServerlessCallbackReportReportColumnPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'columnKey': { schema: stringSchema, optional: false },
  'values': { schema: arraySchema(unionSchema([numberSchema, nullSchema])), optional: false },
}))

export const PhasesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'lengthA': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'lengthB': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'lengthC': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'angleAlpha': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'angleBeta': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'angleGamma': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'volume': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
}))

export const PhasesRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataFile': { schema: lazySchema(() => FilesFilterFileModelSchema), optional: false },
  'cifFiles': { schema: arraySchema(lazySchema(() => FilesFilterFileModelSchema)), optional: false },
  'instrumentalFile': { schema: unionSchema([lazySchema(() => FilesFilterFileModelSchema), nullSchema]), optional: false },
  'cifFilesABC': { schema: recordSchema(lazySchema(() => AbcSchema)), optional: false },
  'wavelength': { schema: lazySchema(() => PeakFittingWavelengthSchema), optional: false },
}))

export const PhasesResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => HistogramSchema), optional: false },
}))

export const PolynomialBaselineModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'baselineFunction': { schema: unionSchema([literalSchema("polynomial")]), optional: false },
  'degree': { schema: numberSchema, optional: false },
}))

export const PoniFileSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'poniVersion': { schema: numberSchema, optional: false },
  'dist': { schema: numberSchema, optional: false },
  'poni1': { schema: numberSchema, optional: false },
  'poni2': { schema: numberSchema, optional: false },
  'rot1': { schema: numberSchema, optional: false },
  'rot2': { schema: numberSchema, optional: false },
  'rot3': { schema: numberSchema, optional: false },
  'detector': { schema: stringSchema, optional: false },
  'detectorConfig': { schema: lazySchema(() => DetectorConfigExtraSchema), optional: false },
  'wavelength': { schema: numberSchema, optional: false },
}))

export const PoniFileDataSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => PoniFileSchema)))

export const ProjectSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'projectName': { schema: stringSchema, optional: false },
  'createdAt': { schema: stringSchema, optional: false },
  'compatibility': { schema: unionSchema([lazySchema(() => ProjectCompatibilitySummarySchema), nullSchema]), optional: true },
  'ownerUserId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'role': { schema: unionSchema([lazySchema(() => ProjectRoleSchema), nullSchema]), optional: true },
  'path': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'analysisHistory': { schema: unionSchema([arraySchema(lazySchema(() => ProjectAnalysisHistoryEntrySchema)), nullSchema]), optional: true },
  'lastRunAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'sharing': { schema: unionSchema([lazySchema(() => ProjectSharingSchema), nullSchema]), optional: true },
  'isDeleted': { schema: booleanSchema, optional: true },
  'deletedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'deletedBy': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ProjectAnalysisCompatibilitySummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
  'status': { schema: lazySchema(() => ProjectCompatibilityStatusSchema), optional: false },
  'inputRemapped': { schema: booleanSchema, optional: true },
  'resultShapeIncompatible': { schema: booleanSchema, optional: true },
  'inputStatus': { schema: lazySchema(() => ProjectInputCompatibilityStatusSchema), optional: true },
  'outputStatus': { schema: lazySchema(() => ProjectOutputCompatibilityStatusSchema), optional: true },
  'rerunAvailable': { schema: booleanSchema, optional: true },
}))

export const ProjectAnalysisHistoryEntrySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
  'lastRunAt': { schema: stringSchema, optional: false },
}))

export const ProjectCompatibilityStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("current"), literalSchema("migrated"), literalSchema("setup_required"), literalSchema("blocked")]))

export const ProjectCompatibilitySummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'overallStatus': { schema: lazySchema(() => ProjectCompatibilityStatusSchema), optional: true },
  'assessmentComplete': { schema: booleanSchema, optional: true },
  'assessedReleaseId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'analyses': { schema: arraySchema(lazySchema(() => ProjectAnalysisCompatibilitySummarySchema)), optional: true },
}))

export const ProjectDownloadBrowseDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'path': { schema: stringSchema, optional: false },
  'files': { schema: arraySchema(stringSchema), optional: false },
  'folders': { schema: arraySchema(stringSchema), optional: false },
  'truncated': { schema: booleanSchema, optional: false },
  'nextContinuationToken': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ProjectDownloadBrowseRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'path': { schema: stringSchema, optional: true },
}))

export const ProjectDownloadBrowseResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ProjectDownloadBrowseDataSchema), optional: false },
}))

export const ProjectDownloadPartSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'partKey': { schema: stringSchema, optional: false },
  'size': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'url': { schema: stringSchema, optional: false },
}))

export const ProjectDownloadSelectionItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'type': { schema: unionSchema([literalSchema("file"), literalSchema("folder")]), optional: false },
  'path': { schema: stringSchema, optional: false },
  'ignoredPaths': { schema: arraySchema(stringSchema), optional: true },
}))

export const ProjectDownloadStartDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'jobId': { schema: stringSchema, optional: false },
  'status': { schema: unionSchema([literalSchema("QUEUED"), literalSchema("RUNNING"), literalSchema("COMPLETED"), literalSchema("FAILED")]), optional: false },
}))

export const ProjectDownloadStartRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'selection': { schema: unionSchema([arraySchema(lazySchema(() => ProjectDownloadSelectionItemSchema)), nullSchema]), optional: true },
}))

export const ProjectDownloadStartResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ProjectDownloadStartDataSchema), optional: false },
}))

export const ProjectDownloadStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("QUEUED"), literalSchema("RUNNING"), literalSchema("COMPLETED"), literalSchema("FAILED")]))

export const ProjectDownloadStatusDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'jobId': { schema: stringSchema, optional: false },
  'projectId': { schema: stringSchema, optional: false },
  'status': { schema: lazySchema(() => ProjectDownloadStatusSchema), optional: false },
  'progress': { schema: numberSchema, optional: false },
  'message': { schema: stringSchema, optional: false },
  'parts': { schema: arraySchema(lazySchema(() => ProjectDownloadPartSchema)), optional: false },
}))

export const ProjectDownloadStatusRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'jobId': { schema: stringSchema, optional: false },
}))

export const ProjectDownloadStatusResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ProjectDownloadStatusDataSchema), optional: false },
}))

export const ProjectInfoSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectInfo': { schema: unionSchema([lazySchema(() => AnalysisRequestTypeSchema), nullSchema]), optional: true },
  'inaccessibleReferences': { schema: arraySchema(stringSchema), optional: true },
  'hasInaccessibleReferences': { schema: booleanSchema, optional: true },
  'success': { schema: booleanSchema, optional: false },
}))

export const ProjectInfoRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
}))

export const ProjectInfoResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ProjectInfoSchema), optional: false },
}))

export const ProjectInputCompatibilityStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("current"), literalSchema("migrated"), literalSchema("setup_required"), literalSchema("missing"), literalSchema("failed")]))

export const ProjectMemberSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'userId': { schema: stringSchema, optional: false },
  'role': { schema: lazySchema(() => ProjectRoleSchema), optional: false },
  'status': { schema: lazySchema(() => ProjectMembershipStatusSchema), optional: false },
  'createdAt': { schema: stringSchema, optional: false },
  'email': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const ProjectMembershipStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("ACTIVE"), literalSchema("REVOKED")]))

export const ProjectOutputCompatibilityStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("current"), literalSchema("legacy"), literalSchema("missing"), literalSchema("unknown")]))

export const ProjectRoleSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("OWNER"), literalSchema("EDITOR")]))

export const ProjectSharingSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sharedWith': { schema: unionSchema([arraySchema(lazySchema(() => ProjectSharingUserSchema)), nullSchema]), optional: true },
  'sharedFrom': { schema: unionSchema([lazySchema(() => ProjectSharingUserSchema), nullSchema]), optional: true },
}))

export const ProjectSharingUserSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'userId': { schema: stringSchema, optional: false },
  'sharedAt': { schema: stringSchema, optional: false },
  'email': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RangeModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'lower': { schema: numberSchema, optional: false },
  'upper': { schema: numberSchema, optional: false },
}))

export const ReadMetaRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'metaFile': { schema: stringSchema, optional: false },
}))

export const ReadMetaResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => MetaInfoSchema), optional: false },
}))

export const RealtimeControlEventSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'type': { schema: lazySchema(() => RealtimeControlEventTypeSchema), optional: false },
  'projectId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'analysisType': { schema: unionSchema([lazySchema(() => AnalysisMethodsSchema), nullSchema]), optional: true },
}))

export const RealtimeControlEventTypeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("onDemandHeartbeat"), literalSchema("runtimeSnapshotRequested")]))

export const RealtimeEventTypeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("taskStatus"), literalSchema("onDemandInstanceStatus"), literalSchema("runtimeSnapshot"), literalSchema("heartbeatAcknowledged"), literalSchema("runtimeError")]))

export const RealtimeRuntimeEventSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'type': { schema: lazySchema(() => RealtimeEventTypeSchema), optional: false },
  'taskStatus': { schema: unionSchema([lazySchema(() => TaskStatusEventSchema), nullSchema]), optional: true },
  'onDemandInstanceStatus': { schema: unionSchema([lazySchema(() => OnDemandInstanceStatusEventSchema), nullSchema]), optional: true },
  'runtimeSnapshot': { schema: unionSchema([lazySchema(() => RuntimeSnapshotEventSchema), nullSchema]), optional: true },
  'heartbeatAcknowledged': { schema: unionSchema([lazySchema(() => HeartbeatAcknowledgedEventSchema), nullSchema]), optional: true },
  'runtimeError': { schema: unionSchema([lazySchema(() => RuntimeErrorEventSchema), nullSchema]), optional: true },
}))

export const RemoteAuthTypeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("PASSWORD"), literalSchema("SSH_KEY")]))

export const RemoteEntryTypeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("file"), literalSchema("folder")]))

export const RemoteImportCancelRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'jobId': { schema: stringSchema, optional: false },
}))

export const RemoteImportCancelResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteImportJobSchema), optional: false },
}))

export const RemoteImportConfirmRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'jobId': { schema: stringSchema, optional: false },
}))

export const RemoteImportConfirmResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteImportJobSchema), optional: false },
}))

export const RemoteImportJobSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'jobId': { schema: stringSchema, optional: false },
  'projectId': { schema: stringSchema, optional: false },
  'sourceId': { schema: stringSchema, optional: false },
  'selected': { schema: arraySchema(lazySchema(() => RemoteImportSelectionItemSchema)), optional: false },
  'state': { schema: lazySchema(() => RemoteImportStateSchema), optional: false },
  'progress': { schema: lazySchema(() => RemoteImportProgressSchema), optional: true },
  'preflight': { schema: unionSchema([lazySchema(() => RemoteImportPreflightSummarySchema), nullSchema]), optional: true },
  'message': { schema: stringSchema, optional: true },
  'errorMessage': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'createdAt': { schema: stringSchema, optional: false },
  'updatedAt': { schema: stringSchema, optional: false },
  'startedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'finishedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteImportPreflightSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'bytesTotal': { schema: numberSchema, optional: true },
  'filesTotal': { schema: numberSchema, optional: true },
  'directoriesTotal': { schema: numberSchema, optional: true },
  'scannedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'topLevel': { schema: arraySchema(lazySchema(() => RemoteImportPreflightTopLevelItemSchema)), optional: true },
}))

export const RemoteImportPreflightTopLevelItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'name': { schema: stringSchema, optional: false },
  'path': { schema: stringSchema, optional: false },
  'bytesTotal': { schema: numberSchema, optional: true },
  'filesTotal': { schema: numberSchema, optional: true },
  'directoriesTotal': { schema: numberSchema, optional: true },
}))

export const RemoteImportProgressSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'bytesTransferred': { schema: numberSchema, optional: true },
  'bytesTotal': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'filesTransferred': { schema: numberSchema, optional: true },
  'filesTotal': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'directoriesTotal': { schema: numberSchema, optional: true },
  'throughputBytesPerSec': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'currentFile': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteImportResumeRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'jobId': { schema: stringSchema, optional: false },
  'mfaCode': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteImportResumeResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteImportJobSchema), optional: false },
}))

export const RemoteImportSelectionItemSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'type': { schema: lazySchema(() => RemoteEntryTypeSchema), optional: false },
  'path': { schema: stringSchema, optional: false },
}))

export const RemoteImportStartRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'sourceId': { schema: stringSchema, optional: false },
  'selected': { schema: arraySchema(lazySchema(() => RemoteImportSelectionItemSchema)), optional: false },
  'analysisType': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'mfaCode': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'sessionId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteImportStartResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteImportJobSchema), optional: false },
}))

export const RemoteImportStateSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("QUEUED"), literalSchema("AUTH_REQUIRED"), literalSchema("PREFLIGHT_SCANNING"), literalSchema("PREFLIGHT_READY"), literalSchema("SCANNING"), literalSchema("TRANSFERRING"), literalSchema("PAUSED_AUTH_REQUIRED"), literalSchema("COMPLETED"), literalSchema("FAILED"), literalSchema("CANCEL_REQUESTED"), literalSchema("CANCELLED")]))

export const RemoteImportStatusRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'jobId': { schema: stringSchema, optional: false },
}))

export const RemoteImportStatusResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteImportJobSchema), optional: false },
}))

export const RemoteListEntrySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'name': { schema: stringSchema, optional: false },
  'path': { schema: stringSchema, optional: false },
  'type': { schema: lazySchema(() => RemoteEntryTypeSchema), optional: false },
  'size': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'modifiedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'permissions': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'owner': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'group': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteProtocolSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("SFTP"), literalSchema("FTPS"), literalSchema("FTP")]))

export const RemoteSftpSessionSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sessionId': { schema: stringSchema, optional: false },
  'sourceId': { schema: stringSchema, optional: false },
  'projectId': { schema: stringSchema, optional: false },
  'state': { schema: lazySchema(() => RemoteSftpSessionStateSchema), optional: false },
  'createdAt': { schema: stringSchema, optional: false },
  'updatedAt': { schema: stringSchema, optional: false },
  'lastUsedAt': { schema: stringSchema, optional: false },
  'expiresAt': { schema: numberSchema, optional: false },
  'maxExpiresAt': { schema: numberSchema, optional: false },
  'message': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteSftpSessionBrowseDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'session': { schema: lazySchema(() => RemoteSftpSessionSchema), optional: false },
  'path': { schema: stringSchema, optional: false },
  'entries': { schema: arraySchema(lazySchema(() => RemoteListEntrySchema)), optional: false },
  'authRequired': { schema: booleanSchema, optional: true },
  'message': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteSftpSessionBrowseRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sessionId': { schema: stringSchema, optional: false },
  'path': { schema: stringSchema, optional: true },
  'limit': { schema: numberSchema, optional: true },
}))

export const RemoteSftpSessionBrowseResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteSftpSessionBrowseDataSchema), optional: false },
}))

export const RemoteSftpSessionCloseRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sessionId': { schema: stringSchema, optional: false },
}))

export const RemoteSftpSessionCloseResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteSftpSessionSchema), optional: false },
}))

export const RemoteSftpSessionCurrentDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'session': { schema: unionSchema([lazySchema(() => RemoteSftpSessionSchema), nullSchema]), optional: true },
  'sourceId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'path': { schema: stringSchema, optional: true },
  'activeJob': { schema: unionSchema([lazySchema(() => RemoteImportJobSchema), nullSchema]), optional: true },
  'message': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteSftpSessionCurrentRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const RemoteSftpSessionCurrentResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteSftpSessionCurrentDataSchema), optional: false },
}))

export const RemoteSftpSessionDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'session': { schema: lazySchema(() => RemoteSftpSessionSchema), optional: false },
  'path': { schema: stringSchema, optional: false },
  'entries': { schema: arraySchema(lazySchema(() => RemoteListEntrySchema)), optional: false },
  'authRequired': { schema: booleanSchema, optional: true },
  'message': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteSftpSessionHeartbeatRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sessionId': { schema: stringSchema, optional: false },
}))

export const RemoteSftpSessionHeartbeatResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteSftpSessionSchema), optional: false },
}))

export const RemoteSftpSessionStartRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'sourceId': { schema: stringSchema, optional: false },
  'path': { schema: stringSchema, optional: true },
  'limit': { schema: numberSchema, optional: true },
  'mfaCode': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'replaceExisting': { schema: booleanSchema, optional: true },
}))

export const RemoteSftpSessionStartResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteSftpSessionDataSchema), optional: false },
}))

export const RemoteSftpSessionStateSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("STARTING"), literalSchema("READY"), literalSchema("BUSY"), literalSchema("AUTH_REQUIRED"), literalSchema("FAILED"), literalSchema("EXPIRED"), literalSchema("CLOSED")]))

export const RemoteSourceSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sourceId': { schema: stringSchema, optional: false },
  'projectId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'name': { schema: stringSchema, optional: false },
  'protocol': { schema: lazySchema(() => RemoteProtocolSchema), optional: false },
  'host': { schema: stringSchema, optional: false },
  'port': { schema: numberSchema, optional: false },
  'username': { schema: stringSchema, optional: false },
  'options': { schema: lazySchema(() => RemoteSourceOptionsSchema), optional: true },
  'requiresPersistentSession': { schema: booleanSchema, optional: true },
  'lastTestStatus': { schema: lazySchema(() => RemoteSourceTestStatusSchema), optional: true },
  'lastTestMessage': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'lastTestAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'createdAt': { schema: stringSchema, optional: false },
  'updatedAt': { schema: stringSchema, optional: false },
}))

export const RemoteSourceAuthRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'authType': { schema: lazySchema(() => RemoteAuthTypeSchema), optional: true },
  'password': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'privateKeyPem': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'passphrase': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteSourceBrowseDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'path': { schema: stringSchema, optional: false },
  'entries': { schema: arraySchema(lazySchema(() => RemoteListEntrySchema)), optional: false },
  'authRequired': { schema: booleanSchema, optional: true },
  'message': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'source': { schema: unionSchema([lazySchema(() => RemoteSourceSchema), nullSchema]), optional: true },
}))

export const RemoteSourceBrowseRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sourceId': { schema: stringSchema, optional: false },
  'path': { schema: stringSchema, optional: true },
  'limit': { schema: numberSchema, optional: true },
  'mfaCode': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteSourceBrowseResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteSourceBrowseDataSchema), optional: false },
}))

export const RemoteSourceDeleteDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'success': { schema: booleanSchema, optional: false },
}))

export const RemoteSourceDeleteRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sourceId': { schema: stringSchema, optional: false },
}))

export const RemoteSourceDeleteResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteSourceDeleteDataSchema), optional: false },
}))

export const RemoteSourceListRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({

}))

export const RemoteSourceListResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: arraySchema(lazySchema(() => RemoteSourceSchema)), optional: false },
}))

export const RemoteSourceOptionsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'defaultPath': { schema: stringSchema, optional: true },
  'ftpPassiveMode': { schema: booleanSchema, optional: true },
  'ftpPreferEpsv': { schema: booleanSchema, optional: true },
  'ftpsTlsVerifyMode': { schema: unionSchema([literalSchema("STRICT"), literalSchema("ALLOW_SELF_SIGNED"), literalSchema("INSECURE_SKIP_VERIFY")]), optional: true },
  'sftpHostKeyFingerprint': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteSourceSaveRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'sourceId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'name': { schema: stringSchema, optional: false },
  'protocol': { schema: lazySchema(() => RemoteProtocolSchema), optional: false },
  'host': { schema: stringSchema, optional: false },
  'port': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'username': { schema: stringSchema, optional: false },
  'auth': { schema: lazySchema(() => RemoteSourceAuthRequestSchema), optional: false },
  'options': { schema: unionSchema([lazySchema(() => RemoteSourceOptionsSchema), nullSchema]), optional: true },
}))

export const RemoteSourceSaveResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteSourceSchema), optional: false },
}))

export const RemoteSourceTestDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'source': { schema: lazySchema(() => RemoteSourceSchema), optional: false },
  'ok': { schema: booleanSchema, optional: false },
  'authRequired': { schema: booleanSchema, optional: true },
  'message': { schema: stringSchema, optional: false },
}))

export const RemoteSourceTestRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'sourceId': { schema: stringSchema, optional: false },
  'path': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'mfaCode': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RemoteSourceTestResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RemoteSourceTestDataSchema), optional: false },
}))

export const RemoteSourceTestStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("UNKNOWN"), literalSchema("CONNECTED"), literalSchema("AUTH_REQUIRED"), literalSchema("FAILED")]))

export const RemoveRingResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RingSchema), optional: false },
}))

export const RenameFolderRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'folderId': { schema: stringSchema, optional: false },
  'newFolderName': { schema: stringSchema, optional: false },
}))

export const RenameFolderResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => FolderSchema), optional: false },
}))

export const RenameProjectRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'projectName': { schema: stringSchema, optional: false },
}))

export const RenameProjectResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: stringSchema, optional: false },
}))

export const ReportColumnPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'columnKey': { schema: stringSchema, optional: false },
  'values': { schema: arraySchema(unionSchema([numberSchema, nullSchema])), optional: false },
}))

export const ReportGraphTemplatesDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'templates': { schema: arraySchema(lazySchema(() => GraphTemplateSchema)), optional: false },
}))

export const ReportGraphTemplatesRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({

}))

export const ReportGraphTemplatesResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ReportGraphTemplatesDataSchema), optional: false },
}))

export const ReportInputDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'reportInput': { schema: unionSchema([lazySchema(() => ReportInputPayloadSchema), nullSchema]), optional: true },
  'success': { schema: booleanSchema, optional: false },
}))

export const ReportInputPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'schemaVersion': { schema: unionSchema([literalSchema(1)]), optional: true },
  'projectId': { schema: stringSchema, optional: false },
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
  'ui': { schema: recordSchema(unknownSchema), optional: true },
}))

export const ReportInputRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
}))

export const ReportInputResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ReportInputDataSchema), optional: false },
}))

export const ReportMetaPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'rowKeys': { schema: arraySchema(stringSchema), optional: false },
  'columnSchema': { schema: arraySchema(stringSchema), optional: false },
  'columnDomains': { schema: unionSchema([recordSchema(stringSchema), nullSchema]), optional: true },
  'metricDefinitions': { schema: unionSchema([arraySchema(lazySchema(() => ReportMetricDefinitionSchema)), nullSchema]), optional: true },
  'units': { schema: unionSchema([recordSchema(stringSchema), nullSchema]), optional: true },
}))

export const ReportMetricDefinitionSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'key': { schema: stringSchema, optional: false },
  'label': { schema: stringSchema, optional: false },
  'group': { schema: stringSchema, optional: false },
  'unit': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'hasUncertainty': { schema: booleanSchema, optional: false },
  'valueKey': { schema: stringSchema, optional: false },
  'uncertaintyKey': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RerunProjectAnalysisDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'success': { schema: booleanSchema, optional: false },
  'runId': { schema: stringSchema, optional: false },
}))

export const RerunProjectAnalysisRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
}))

export const RerunProjectAnalysisResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RerunProjectAnalysisDataSchema), optional: false },
}))

export const RestoreProjectRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const RestoreProjectResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: stringSchema, optional: false },
  'project': { schema: lazySchema(() => ProjectSchema), optional: false },
  'folders': { schema: arraySchema(lazySchema(() => FolderSchema)), optional: false },
}))

export const RevokeProjectMemberRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'memberUserId': { schema: stringSchema, optional: false },
}))

export const RevokeProjectMemberResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: stringSchema, optional: false },
}))

export const RietveldCifFileParametersSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'rsquared': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'cifFiles': { schema: recordSchema(lazySchema(() => RietveldCifFilePropertiesSchema)), optional: false },
}))

export const RietveldCifFilePropertiesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'weightFraction': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'phaseFraction': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'mustrain': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'crystalliteSize': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'latticeParameterA': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'latticeParameterB': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'latticeParameterC': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
}))

export const RietveldFittingDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: arraySchema(numberSchema), optional: false },
  'ycalc': { schema: arraySchema(numberSchema), optional: false },
  'yobs': { schema: arraySchema(numberSchema), optional: false },
  'background': { schema: arraySchema(numberSchema), optional: false },
  'residual': { schema: arraySchema(numberSchema), optional: false },
}))

export const RietveldInputsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'crystalliteSize': { schema: recordSchema(numberSchema), optional: false },
  'mustrain': { schema: recordSchema(numberSchema), optional: false },
  'refinementRange': { schema: lazySchema(() => RangeModelSchema), optional: false },
}))

export const RietveldParametersSchema: RuntimeSchema = lazySchema(() => recordSchema(lazySchema(() => RietveldCifFileParametersSchema)))

export const RietveldRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'userId': { schema: stringSchema, optional: false },
  'files': { schema: lazySchema(() => FilesAnalysisModelSchema), optional: false },
  'inputs': { schema: lazySchema(() => RietveldInputsSchema), optional: false },
}))

export const RietveldServerlessCallbackFittingCallbackFittingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
}))

export const RietveldServerlessCallbackParametersCallbackParametersRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataFiles': { schema: arraySchema(stringSchema), optional: false },
}))

export const RietveldServerlessCallbackParametersCallbackParametersResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RietveldParametersSchema), optional: false },
}))

export const RietveldServerlessCallbackReportCallbackReportRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'columnKey': { schema: stringSchema, optional: false },
}))

export const RietveldServerlessCallbackReportCallbackReportResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RietveldServerlessCallbackReportReportColumnPayloadSchema), optional: false },
}))

export const RietveldServerlessCallbackReportMetaCallbackReportMetaRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const RietveldServerlessCallbackReportMetaCallbackReportMetaResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => RietveldServerlessCallbackReportMetaReportMetaPayloadSchema), optional: false },
}))

export const RietveldServerlessCallbackReportMetaReportMetaPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'rowKeys': { schema: arraySchema(stringSchema), optional: false },
  'columnSchema': { schema: arraySchema(stringSchema), optional: false },
  'mask': { schema: unionSchema([arraySchema(booleanSchema), nullSchema]), optional: true },
  'rsquaredByPartition': { schema: unionSchema([recordSchema(arraySchema(unionSchema([numberSchema, nullSchema]))), nullSchema]), optional: true },
  'columnPartitions': { schema: unionSchema([recordSchema(numberSchema), nullSchema]), optional: true },
}))

export const RietveldServerlessCallbackReportReportColumnPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'columnKey': { schema: stringSchema, optional: false },
  'values': { schema: arraySchema(unionSchema([numberSchema, nullSchema])), optional: false },
}))

export const RingSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'peaks': { schema: arraySchema(lazySchema(() => MaskedRingSchema)), optional: false },
  'center': { schema: lazySchema(() => CoordinateIntRequiredSchema), optional: false },
  'estimatedRadii': { schema: arraySchema(numberSchema), optional: false },
}))

export const RotationSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: numberSchema, optional: false },
  'y': { schema: numberSchema, optional: false },
  'z': { schema: numberSchema, optional: false },
}))

export const RumBrowserContextSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'browser': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'browserVersion': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'device': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'os': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'viewportWidth': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'viewportHeight': { schema: unionSchema([numberSchema, nullSchema]), optional: true },
  'language': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
}))

export const RumWebVitalNameSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("CLS"), literalSchema("FCP"), literalSchema("FID"), literalSchema("INP"), literalSchema("LCP"), literalSchema("TTFB"), literalSchema("page_load"), literalSchema("navigation")]))

export const RumWebVitalRatingSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("good"), literalSchema("needs-improvement"), literalSchema("poor"), literalSchema("unknown")]))

export const RuntimeErrorEventSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'message': { schema: stringSchema, optional: false },
  'projectId': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'analysisType': { schema: unionSchema([lazySchema(() => AnalysisMethodsSchema), nullSchema]), optional: true },
}))

export const RuntimeSnapshotEventSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'tasks': { schema: arraySchema(lazySchema(() => TaskStatusEventSchema)), optional: true },
  'onDemandInstances': { schema: arraySchema(lazySchema(() => OnDemandInstanceStatusEventSchema)), optional: true },
}))

export const S3FileCheckSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'exists': { schema: booleanSchema, optional: false },
  'link': { schema: stringSchema, optional: false },
}))

export const SameValuesSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'ab': { schema: booleanSchema, optional: false },
  'ac': { schema: booleanSchema, optional: false },
  'bc': { schema: booleanSchema, optional: false },
}))

export const SaveProjectInfoDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'success': { schema: booleanSchema, optional: false },
}))

export const SaveProjectInfoRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
  'analysis': { schema: lazySchema(() => AnalysisRequestTypeSchema), optional: false },
}))

export const SaveProjectInfoResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => SaveProjectInfoDataSchema), optional: false },
}))

export const SaveReportInputDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'reportInput': { schema: lazySchema(() => ReportInputPayloadSchema), optional: false },
  'success': { schema: booleanSchema, optional: false },
}))

export const SaveReportInputRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'analysisType': { schema: lazySchema(() => AnalysisMethodsSchema), optional: false },
  'ui': { schema: recordSchema(unknownSchema), optional: false },
}))

export const SaveReportInputResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => SaveReportInputDataSchema), optional: false },
}))

export const SelectionFiltersModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'selectionMode': { schema: unionSchema([literalSchema("all"), literalSchema("none")]), optional: false },
  'dataFiles': { schema: arraySchema(stringSchema), optional: false },
}))

export const ServerlessCallbackFittingCallbackFittingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
}))

export const ServerlessCallbackFittingCallbackFittingResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => PeakFittingPartitionFittingDataFileSchema), optional: false },
}))

export const ServerlessCallbackParametersCallbackParametersRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataFiles': { schema: arraySchema(stringSchema), optional: false },
}))

export const ServerlessCallbackParametersCallbackParametersResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => DataFilePhaseCifSchema), optional: false },
}))

export const ServerlessCallbackReportCallbackReportRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'columnKey': { schema: stringSchema, optional: false },
}))

export const ServerlessCallbackReportCallbackReportResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ServerlessCallbackReportReportColumnPayloadSchema), optional: false },
}))

export const ServerlessCallbackReportMetaCallbackReportMetaRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const ServerlessCallbackReportMetaCallbackReportMetaResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ServerlessCallbackReportMetaReportMetaPayloadSchema), optional: false },
}))

export const ServerlessCallbackReportMetaReportMetaPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'rowKeys': { schema: arraySchema(stringSchema), optional: false },
  'columnSchema': { schema: arraySchema(stringSchema), optional: false },
  'mask': { schema: unionSchema([arraySchema(booleanSchema), nullSchema]), optional: true },
  'rsquaredByPartition': { schema: unionSchema([recordSchema(arraySchema(unionSchema([numberSchema, nullSchema]))), nullSchema]), optional: true },
  'columnPartitions': { schema: unionSchema([recordSchema(numberSchema), nullSchema]), optional: true },
}))

export const ServerlessCallbackReportReportColumnPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'columnKey': { schema: stringSchema, optional: false },
  'values': { schema: arraySchema(unionSchema([numberSchema, nullSchema])), optional: false },
}))

export const ShareFolderInviteSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'token': { schema: stringSchema, optional: false },
}))

export const ShareFolderRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'folderId': { schema: stringSchema, optional: false },
}))

export const ShareFolderResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => FolderSchema), optional: false },
  'projectInvites': { schema: arraySchema(lazySchema(() => ShareFolderInviteSchema)), optional: false },
  'sharedProjectsCount': { schema: numberSchema, optional: false },
  'sharedSubfoldersCount': { schema: numberSchema, optional: false },
}))

export const ShareProjectRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'token': { schema: stringSchema, optional: false },
}))

export const ShareProjectResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => ProjectSchema), optional: false },
}))

export const SplineBaselineModelSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'baselineFunction': { schema: unionSchema([literalSchema("spline")]), optional: false },
  'numKnots': { schema: numberSchema, optional: false },
}))

export const StatusSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'status': { schema: lazySchema(() => EcsStatusSchema), optional: false },
}))

export const StressFittingSchema: RuntimeSchema = lazySchema(() => recordSchema(recordSchema(lazySchema(() => StressFittingPeakSchema))))

export const StressFittingPeakSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'center': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'strain': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'corrAngle': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'rsquared': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
}))

export const StressParameterComponentSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'key': { schema: stringSchema, optional: false },
  'label': { schema: stringSchema, optional: false },
  'value': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
}))

export const StressParametersSchema: RuntimeSchema = lazySchema(() => recordSchema(recordSchema(lazySchema(() => StressParametersPeakSchema))))

export const StressParametersPeakSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'strainComponents': { schema: arraySchema(lazySchema(() => StressParameterComponentSchema)), optional: false },
  'stressComponents': { schema: arraySchema(lazySchema(() => StressParameterComponentSchema)), optional: false },
  'vonMises': { schema: lazySchema(() => ValueUncertaintySchema), optional: false },
  'principalStresses': { schema: arraySchema(lazySchema(() => StressParameterComponentSchema)), optional: false },
  'principalAngleDeg': { schema: unionSchema([arraySchema(lazySchema(() => StressParameterComponentSchema)), nullSchema]), optional: true },
}))

export const StressStrainInputsSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'peakFitting': { schema: lazySchema(() => PeakFittingInputsModelSchema), optional: false },
  'rotation': { schema: lazySchema(() => RotationSchema), optional: false },
  'stressPeaks': { schema: arraySchema(arraySchema(lazySchema(() => StressStrainPeaksSchema))), optional: false },
  'planeStressCondition': { schema: booleanSchema, optional: false },
  'biaxialMode': { schema: lazySchema(() => BiaxialModeSchema), optional: true },
  'azimuthalRange': { schema: lazySchema(() => AzimuthalRangeSchema), optional: false },
  'numberOfBins': { schema: numberSchema, optional: false },
  'r2Threshold': { schema: numberSchema, optional: false },
  'tthReferenceMode': { schema: lazySchema(() => TthReferenceModeSchema), optional: true },
  'tthReferenceFile': { schema: unionSchema([lazySchema(() => FilesFilterFileModelSchema), nullSchema]), optional: true },
}))

export const StressStrainPeaksSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'youngsModulus': { schema: numberSchema, optional: false },
  'poissonRatio': { schema: numberSchema, optional: false },
  'tthRef': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'included': { schema: booleanSchema, optional: false },
}))

export const StressStrainRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'userId': { schema: stringSchema, optional: false },
  'files': { schema: lazySchema(() => FilesAnalysisModelSchema), optional: false },
  'inputs': { schema: lazySchema(() => StressStrainInputsSchema), optional: false },
  'maskCreator': { schema: unionSchema([lazySchema(() => MaskCreatorStateSchema), nullSchema]), optional: true },
}))

export const StressStrainServerlessCallbackFittingCallbackFittingRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataViewFile': { schema: stringSchema, optional: false },
}))

export const StressStrainServerlessCallbackFittingCallbackFittingResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => PeakFittingPartitionFittingDataFileSchema), optional: false },
}))

export const StressStrainServerlessCallbackParametersCallbackParametersRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'dataFiles': { schema: arraySchema(stringSchema), optional: false },
}))

export const StressStrainServerlessCallbackParametersCallbackParametersResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => DataObjectSchema), optional: false },
}))

export const StressStrainServerlessCallbackReportCallbackReportRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'columnKey': { schema: stringSchema, optional: false },
}))

export const StressStrainServerlessCallbackReportCallbackReportResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => StressStrainServerlessCallbackReportReportColumnPayloadSchema), optional: false },
}))

export const StressStrainServerlessCallbackReportMetaCallbackReportMetaRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
}))

export const StressStrainServerlessCallbackReportMetaCallbackReportMetaResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => StressStrainServerlessCallbackReportMetaReportMetaPayloadSchema), optional: false },
}))

export const StressStrainServerlessCallbackReportMetaReportMetaPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'rowKeys': { schema: arraySchema(stringSchema), optional: false },
  'frameRowKeys': { schema: arraySchema(stringSchema), optional: false },
  'peaks': { schema: arraySchema(stringSchema), optional: false },
  'columnSchema': { schema: arraySchema(stringSchema), optional: false },
  'columnDomains': { schema: recordSchema(stringSchema), optional: false },
  'metricDefinitions': { schema: arraySchema(lazySchema(() => CallbackReportMetaReportMetricDefinitionSchema)), optional: false },
}))

export const StressStrainServerlessCallbackReportReportColumnPayloadSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'columnKey': { schema: stringSchema, optional: false },
  'values': { schema: arraySchema(unionSchema([numberSchema, nullSchema])), optional: false },
}))

export const TaskJobKindSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("analysis"), literalSchema("remoteImport")]))

export const TaskRunStatusSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("queued"), literalSchema("starting"), literalSchema("running"), literalSchema("completed"), literalSchema("failed"), literalSchema("cancelled")]))

export const TaskShardSummarySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'total': { schema: numberSchema, optional: true },
  'running': { schema: numberSchema, optional: true },
  'completed': { schema: numberSchema, optional: true },
  'failed': { schema: numberSchema, optional: true },
  'cancelled': { schema: numberSchema, optional: true },
}))

export const TaskStatusEventSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'runId': { schema: stringSchema, optional: false },
  'ownerUserId': { schema: stringSchema, optional: false },
  'jobKind': { schema: lazySchema(() => TaskJobKindSchema), optional: false },
  'projectId': { schema: stringSchema, optional: false },
  'projectName': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'analysisType': { schema: unionSchema([lazySchema(() => AnalysisMethodsSchema), nullSchema]), optional: true },
  'targetRoute': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'status': { schema: lazySchema(() => TaskRunStatusSchema), optional: false },
  'running': { schema: booleanSchema, optional: false },
  'progress': { schema: numberSchema, optional: false },
  'progressMessage': { schema: stringSchema, optional: false },
  'startedAt': { schema: stringSchema, optional: false },
  'finishedAt': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'lastUpdated': { schema: stringSchema, optional: false },
  'terminal': { schema: booleanSchema, optional: false },
  'errorMessage': { schema: unionSchema([stringSchema, nullSchema]), optional: true },
  'eventVersion': { schema: numberSchema, optional: false },
  'shardSummary': { schema: unionSchema([lazySchema(() => TaskShardSummarySchema), nullSchema]), optional: true },
}))

export const TrashedProjectsRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({

}))

export const TrashedProjectsResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projects': { schema: arraySchema(lazySchema(() => ProjectSchema)), optional: false },
}))

export const TthReferenceModeSchema: RuntimeSchema = lazySchema(() => unionSchema([literalSchema("single"), literalSchema("perFrame"), literalSchema("perBin"), literalSchema("perFrameBin")]))

export const UpdateReportGraphTemplateRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'templateId': { schema: stringSchema, optional: false },
  'name': { schema: stringSchema, optional: false },
  'settings': { schema: recordSchema(unknownSchema), optional: false },
}))

export const UpdateReportGraphTemplateResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: unionSchema([lazySchema(() => GraphTemplateSchema), nullSchema]), optional: false },
}))

export const UploadUrlDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'uploadUrl': { schema: stringSchema, optional: false },
  'fileRef': { schema: stringSchema, optional: false },
}))

export const UploadUrlRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'files': { schema: arraySchema(stringSchema), optional: false },
}))

export const UploadUrlResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: recordSchema(lazySchema(() => UploadUrlDataSchema)), optional: false },
}))

export const UserProjectsRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({

}))

export const UserProjectsWithFoldersResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projects': { schema: arraySchema(lazySchema(() => ProjectSchema)), optional: false },
  'folders': { schema: arraySchema(lazySchema(() => FolderSchema)), optional: false },
}))

export const ValueUncertaintySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'value': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
  'uncertainty': { schema: unionSchema([numberSchema, nullSchema]), optional: false },
}))

export const WavelengthDataSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'wavelength': { schema: numberSchema, optional: false },
}))

export const WavelengthRequestSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'projectId': { schema: stringSchema, optional: false },
  'instrumentalFile': { schema: stringSchema, optional: false },
}))

export const WavelengthResponseSchema: RuntimeSchema = lazySchema(() => objectSchema({
  'data': { schema: lazySchema(() => WavelengthDataSchema), optional: false },
}))

export const XySchema: RuntimeSchema = lazySchema(() => objectSchema({
  'x': { schema: numberSchema, optional: false },
  'y': { schema: numberSchema, optional: false },
}))
